export default {
    "corporate": "Kurumsal program",
    "onboarding": {
        "goal_desc": "Aktivitenizi takip ettiğinizde %{customPoints} ve amaçlarınızı tamamladığınızda bonus %{customPoints} kazanacaksınız. Başlamanın zamanı geldi. Herhangi bir anda aktif 3 kişisel amacınız olabilir.",
        "sample_task": {
            "modalActivityTitle": "3 derin nefes",
            "rewards_featured_title": "Öne çıkan",
            "rewards_partners_title": "Ortaklar",
            "header_description": "Aktivitenizi takip ederek ve görevleri, amaçları ve yarışmaları tamamlayarak %{customPoints} kazanırsınız.",
            "icon_text": "Derin bir nefesi takip etmek için {icon} öğesine dokunun.",
            "activityName": "derin nefes alma",
            "activityUnit": "nefes"
        },
        "lets_get_started": "Hadi başlayalım!",
        "start_description": "Aktivitenizi takip ederek ve görevleri, amaçları ve yarışmaları tamamlayarak %{customPoints} kazanırsınız.",
        "complete_and_earn": "Tamamla ve kazan",
        "did_it": "Başardım!",
        "task_complete": "Görev tamamlandı!",
        "breath_sample_task": "Aktivite takibi hakkında kısa bir eğitim alın",
        "track_a_sample_activity": "Örnek bir aktiviteyi takip edin",
        "nice": "Güzel!",
        "nice_one": "Güzel!",
        "nice_subtext_1": "%{points} %{customPoints} kazandınız.",
        "nice_subtext_2": "%{customPoints} kazanmak seviye atlamanıza yardımcı olacaktır. Her seviye atladığınızda, harika teklifler için kullanılabilen %{reward_currency} kazanırsınız.",
        "nice_subtext_3": "Daha fazla görevi tamamladığınızda, aktiviteyi takip ettiğinizde, amaç ve yarışmaları tamamladığınızda daha fazla puan kazanırsınız.",
        "progress_subtitle": "%{customPoints} ve ilerlemeniz şu sıklıkla sıfırlanır: %{frequency}.",
        "skip_for_now": "Şimdilik atla",
        "loadingText": "Biz iyilik hali puanınızı hesaplarken sabırlı olun.",
        "goal_title": "Kişiselleştirilmiş bir amaç belirleyin",
        "swipe_for_more": "Daha fazlasını görmek için kaydırın",
        "skip_goals": "Şimdilik amaç belirlemeyi bitirdim.",
        "complete_profile": "",
        "level": "Seviye",
        "finish_onboarding_action": "Lütfen önce katılım sürecini tamamlayın",
        "vital_stats": {
            "height_ft": "Boy ft.",
            "height_in": "Boy in."
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Gizliliğiniz önemlidir"
        },
        "levels": {
            "title": "Başarılar ve ödüller",
            "tableTitle": "Başarı"
        },
        "initialScreen": {
            "title": "%{programName} programına hoş geldiniz %{username}.",
            "getRewarded": "%{rewardName} ile ödüllendirilin",
            "completeAgainst": "İş arkadaşlarınıza karşı yarışın",
            "earnPoints": "Sağlıklı yaşam aktiviteleriyle puan kazanın",
            "levelUp": "Seviye atlayın ve rozetlerin kilidini açın"
        },
        "starterGoals": {
            "title": "Bir amaç seçin",
            "subtitle": "Sağlıklı yaşam yolculuğunuza yeni bir sağlıklı alışkanlıkla başlayın."
        }
    },
    "healthkit_not_available": "Apple Health ile bağlantı kurulamıyor. Health uygulamasında, Kaynaklar altında, en azından adımlar için etkin izniniz olduğundan ve en az 1 adımın takip edildiğinden emin olun.",
    "changeCover": "Fotoğrafı değiştir",
    "joiningCommunityToast": {
        "success": {
            "message": "%{name} adlı topluluğa başarıyla katıldınız",
            "title": "Topluluğa katıl"
        }
    },
    "achievement_starts_date": "Başlama: %{date}",
    "editChallenge": "Şunu düzenle: %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "En fazla 5 aktivite seçin",
            "title": "Ne yapmak istersiniz?",
            "noActivityTitle": "Aktiviteler ekleniyor",
            "noActivityMessage": "En az bir aktivite veya kategori seçin.",
            "categoryItemDescription": "%{category} kategorisindeki tüm aktiviteler",
            "addActivityTitle": "%{period} başına kaç %{unit} %{activity} yapmak istiyorsunuz?",
            "addCategoryQuantityTitle": "%{category} kategorisinde kaç %{customPoints} kazanmak istiyorsunuz?",
            "subtitleCategories": "Bir kategori seçin. Bu kategorideki tüm faaliyetler amaca katkıda bulunacaktır.",
            "subtitleWithActivities": "%{num} \/ %{max} aktivite seçildi",
            "selectCategoryMessage": "Kategorideki tüm aktiviteler seçilecek ve daha önce seçilen aktiviteler iptal edilecektir.",
            "addActivityTitleTotal": "%{period} içerisinde ne kadar %{activity} yapmak istiyorsunuz?"
        },
        "inviteDepartments": {
            "title": "Departmanları \/ bölümleri davet et"
        },
        "inviteRegions": {
            "title": "Bölgeleri davet et"
        },
        "createInvitation": {
            "selectMore": "Lütfen en az 2 %{entity} seçin."
        },
        "visibility": {
            "title": "Görünürlük",
            "description": "Tüm %{programName} kullanıcıları ekip yarışmalarını bulabilir ve bunlara katılabilir."
        },
        "highest": {
            "name": "En çok %{customPoints} kazanan",
            "description": "Sınır yok, en yüksek %{customPoints} 1. sırayı alır"
        },
        "compete": {
            "individual": "Bireysel olarak yarışın",
            "team": "Ekip olarak yarışın"
        },
        "unitType": {
            "title": "Amacınızı nasıl tamamlayacağınızı seçin",
            "subtitle": "Aktivitelerden veya kategorilerden birini seçin"
        },
        "category": {
            "name": "Bir kategorideki tüm aktiviteler",
            "description": "Örn. \"Hareket\" bölümündeki herhangi bir aktiviteyi takip edin",
            "title": "Bir kategori seçin",
            "subtitle": "Aktiviteleri hangi kategoriden takip edeceksiniz?"
        },
        "activities": {
            "name": "Seçilmiş aktiviteler",
            "description": "Örn. Bisiklete binme gibi belirli aktiviteleri takip edin",
            "title": "Aktiviteleri seçin",
            "subtitle": "Tek bir aktiviteye odaklanmanızı öneririz ancak 5'e kadar ekleyebilirsiniz",
            "maxModalTitle": "Maksimum sayıda aktivite seçildi",
            "maxModalDescription": "En fazla 5 aktivite ekleyebilirsiniz. 5 seçili aktivitenizle devam etmek için Kabul Et'e veya değişiklik yapmak için Düzenle'ye dokunun.",
            "warningModalTitle": "Yüksek zorluk derecesi",
            "warningModalDescription": "Bu hedefte dönem başına tamamlanması gereken çok sayıda aktivite belirttiniz. Bu kadar zorlu bir amaç belirlemek istediğinizden emin misiniz?",
            "requiredPoints": "%{period} %{challengeType} amacına ulaşmak için gerekli",
            "noActivitiesModalTitle": "Aktiviteler ekleniyor",
            "noActivitiesModalDescription": "En az bir aktivite seçin."
        },
        "categoryQuantity": {
            "title": "%{customPoints} amacınızı belirleyin",
            "subtitle": "Her %{period} içinde %{category} kategorisinden kaç %{customPoints} kazanmak istiyorsunuz?",
            "subtitleTotal": "%{category} %{period} ile kaç %{customPoints} kazanmak istiyorsunuz?",
            "text": "Bir kılavuz olarak, 30 dakikalık orta yoğunlukta aktivite şuna eşittir: yaklaşık 105 %{customPoints}",
            "noQuantityModalTitle": "Miktar",
            "noQuantityModalDescription": "Bir değer girin",
            "defaultCategoryTitle": "geçerli kategori"
        },
        "cancel": {
            "title": "Yarışma oluşturmayı iptal et",
            "message": "Yarışma oluşturmayı iptal etmek istediğinizden emin misiniz?"
        },
        "createNew": "Yeni yarışma oluştur",
        "chooseChallengeTitle": "Bir yarışma seçin veya kendi yarışmanızı oluşturun",
        "createOwn": {
            "title": "Benimkini oluştur"
        },
        "frequency": {
            "title": "Amacınıza ne sıklıkla ulaşacaksınız?",
            "subtitle": "Günlük amaçlar, harika alışkanlık oluşturuculardır"
        },
        "startAndDuration": {
            "title": "Bir başlangıç tarihi ve süre seçin",
            "subtitle": "",
            "noFieldsTitle": "Başlangıç tarihi ve süre",
            "noFieldsMessage": "Lütfen başlangıç tarihini ve süreyi girin"
        },
        "finalize": {
            "title": "Yeni amacınızı gözden geçirin",
            "subtitle": "",
            "noFieldsTitle": "İsim ve talimatlar",
            "noFieldsMessage": "Lütfen isim ve talimatlar alanlarını doldurun",
            "name": "%{frequency} %{names} amacım",
            "instructionCategory": "Tüm %{category} aktivitelerinden %{points} %{customPoints} %{frequency} kazanın",
            "instructionActivities": "%{items} %{frequency} takibi ile %{points} %{customPoints} %{pointsFrequency} kazanın",
            "instructionCompetitionCategory": "Bu müsabakayı kazanmak için tüm %{category} aktivitelerinden en yüksek %{customPoints} puanını toplayın",
            "instructionCompetitionActivities": "Bu müsabakayı kazanmak için %{items} ile en yüksek %{customPoints} puanını toplayın",
            "namePlaceholder": "Müsabakanıza bir isim verin",
            "titleChallenge": "Yarışmanızı son haline getirin"
        },
        "dailyDescription": "Örn. Her gün 8 bardak su için",
        "weeklyDescription": "Örn. Her hafta 150 dakika yürüyün",
        "monthlyDescription": "Örn. Her ay 150 km koşun",
        "totalDescription": "Örn. Toplamda 10.000 km bisiklet sürün",
        "title": "Kendinize veya başkalarına meydan okumak mı istiyorsunuz?",
        "navigatorTitle": "Bir yarışma oluşturun",
        "me": {
            "name": "Sadece ben",
            "description": "Kişisel bir amaçla kendinize meydan okuyun"
        },
        "others": {
            "name": "Başkalarıyla rekabet edin",
            "description": "Bireysel olarak veya ekip halinde rekabet edin"
        },
        "one": {
            "name": "Bireysel olarak",
            "description": "Bireysel olarak diğer kullanıcılarla rekabet edin"
        },
        "team": {
            "name": "Ekip olarak",
            "description": "Ekip olarak diğer ekiplerle yarışın"
        },
        "company": {
            "name": "Şirket yarışması",
            "description": "Özel müsabaka oluşturun"
        },
        "adminItemTitle": "Yönetici olarak şunları oluşturabilirsiniz:",
        "userOrTeamTitle": "Bireysel olarak mı yoksa ekip halinde mi yarışacaksınız?",
        "target": {
            "name": "Ulaşmak için bir amaç belirleyin",
            "description": "Üst sınırı olan yarışma"
        },
        "typeTitle": "Bir %{challengeType} türü seçin",
        "teamSizeTitle": "Her ekip için büyüklük seçin",
        "teamSizeSubtitle": "Bir ekibin minimum boyutu %{min}, maksimum boyutu %{max} olabilir. Ekibinizin %{customPoints} değeri, ekipteki tüm üyelerin ortalamasıdır ve yalnızca ekibiniz minimum üye sayısına ulaştığında %{customPoints} kazanabilirsiniz.",
        "teamSize": {
            "noFieldsTitle": "Minimum ve maksimum",
            "noFieldsMessage": "Bir ekip için minimum ve maksimum üye sayısını seçin"
        },
        "companyChallengeTitle": "Şirket yarışması",
        "companyChallengeSubtitle": "Siz bir yöneticisiniz. Departmanlar temelinde ve başka yarışmalar ayarlayabilirsiniz",
        "chooseDepartmentTitle": "Rekabet etmek için departman \/ bölüm seçin",
        "chooseRegionTitle": "Rekabet etmek için bölge seçin",
        "goToChallenge": "Yarışmama git",
        "additional": {
            "title": "Yarışma oluşturuldu",
            "subtitle": "Hadi başlayalım! Başkalarını katılmaya davet edin.",
            "makePublicName": "Bunu herkese açık hale getirin",
            "makePublicDescription": "Herkes katılabilir",
            "toDirectoryName": "Yarışma Dizinine Gönder",
            "toDirectoryDescription": "İnsanlar tıpkı bunun gibi bir tane oluşturabilir",
            "inviteTitle": "Yarışmaya davet edin",
            "titleGoal": "Amaç oluşturuldu."
        },
        "quantityMinimum": {
            "message": "Gerekli minimum miktar: %{quantity}",
            "title": "Yetersiz Miktar"
        },
        "toast": {
            "success": "%{challengeType} oluşturuldu."
        },
        "goToGoal": "Amacıma git",
        "navigatorTitleGoal": "Bir amaç oluşturun",
        "quantityError": {
            "wholeNumber": "Tamsayı olmalıdır",
            "greaterThanZero": "0'dan büyük olmalıdır"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "İyilik hali puanınız, iyilik hali anketinde verdiğiniz yanıtların sizinle aynı yaş ve cinsiyet kategorisindeki milyonlarca diğer kişinin yanıtlarıyla karşılaştırılmasıyla hesaplanır. Puanınız, onlara göre sıralamanızı gösterir. Puanınız, uygulamaya girilen hareket, yeme ve hissetme davranışlarınızdaki değişikliklere göre her ay otomatik olarak güncellenir. Tutarlı amaç belirleme ve sağlığınızı iyileştirmek için olumlu adımlar atma, iyilik hali puanınızı artırmanıza yardımcı olabilir.",
            "excellent": "Sağlık puanınız, sizinle aynı yaşta ve cinsiyette olan kişilerin %85'inden daha iyi. ",
            "very_good": "Sağlık puanınız, sizinle aynı yaşta ve cinsiyette olan kişilerin %70-84'ünden daha iyi.",
            "good": "Sağlık puanınız, sizinle aynı yaşta ve cinsiyette olan kişilerin %51-69'undan daha iyi.",
            "fair": "Sağlık puanınız, sizinle aynı yaşta ve cinsiyette olan kişilerin %31-50'sinden daha iyi.",
            "poor": "Sağlık puanınız, sizin yaşınızdaki ve cinsiyetinizdeki insanların %70'inden düşük. Sağlığınıza öncelik vermeye başlamanın yaşı yoktur. Sağlıklı yaşam yolculuğunuzda ilerlemenize yardımcı olabilecek platformumuzdan yararlanın.",
            "overall_result": "Genel olarak iyilik hali puanınız: %{status}.",
            "category_result": "Genel olarak {category} puanınız: {string}.",
            "goals": "Amacınız olmadan kazanamazsınız. En fazla 3 kişisel amaç belirleyin ve bunlar doğrultusunda ilerleyin. Zamanla yaşam tarzınızda değişiklikler yaptıkça puanınızın arttığını göreceksiniz."
        },
        "reminder": {
            "title": "İyilik hali anketinizi güncellemenin zamanı geldi.",
            "updateAnswers": "Cevaplarımı güncelle"
        },
        "lastUpdated": "Son güncelleme: %{date}",
        "scoreDescription": {
            "part1": "Puanınız:",
            "part2": "puan:",
            "belowAverage": "ortalamanın altında",
            "aboveAverage": "ortalamanın üstünde",
            "part3": "- sizin yaşınızdaki ve cinsiyetinizdeki diğer kişiler için."
        },
        "improveScore": {
            "description": "Puanınız, iyilik hali anketi yanıtlarınıza ve takip edilen aktivitenize göre hesaplanır. Anket yanıtlarınızı güncelleyebilir veya geliştirmek için yeni amaçlar belirleyebilirsiniz.",
            "desc1": "Puanınız bundan daha yüksek olamaz. Rutinlerinizi ilginç kılmak için, normal kapasitenizin biraz üzerinde hedeflerle kendinize meydan okuyun ve motivasyonunuzu korumak için başkalarını sizinle rekabet etmeye davet edin.",
            "desc2": "Seviye atlamaya hazırsanız zorluğu artırmanın zamanı geldi. Normal kapasitenizin biraz üzerinde hedeflerle kendinize meydan okuyun ve motivasyonunuzu korumak için başkalarını sizinle rekabet etmeye davet edin.",
            "desc3": "Kişisel amaçlar belirleyin, kendinizi sorumlu tutmak ve motivasyonunuzu korumak için herkese açık yarışmalar oluşturun. Ulaşılabilir hedefler ve kısa zaman dilimleri seçtiğinizden emin olun. Zaman dilimi olarak biz 1 hafta öneriyoruz.",
            "desc4": "Her gün aktif olmak önemlidir. Günlük rutininizde çok fazla hareket yoksa yeteneklerinize ve ilgi alanlarınıza uyan küçük amaçlarla başlayın. Ulaşılabilir hedefler ve kısa zaman dilimleri seçtiğinizden emin olun. Zaman dilimi olarak biz 1 hafta öneriyoruz."
        },
        "recommendedGoals": "Önerilen amaçlar",
        "recommendedDescription": {
            "desc1": "En fazla ",
            "desc2": "3 amaç ",
            "desc3": "belirleyerek i̇yilik halinizi iyileştirmeye odaklanın. Şu anda şu kadar var: "
        },
        "categoryScore": "%{category} puanınız: ",
        "learnMore": "Daha fazla bilgi edinin",
        "youAreSet": "Artık hazırsınız.",
        "goalSetting": "Amaç belirleme",
        "attention": "%{category} puanı mevcut değil.",
        "move": {
            "error": "Cevaplarınıza göre hareket puanınız mevcut değil. "
        },
        "eat": {
            "error": "Bir sağlık uzmanının size Tip 2 Diyabet hastası olduğunuzu söylediğini ve bunun kontrol edilmediğini belirttiniz. "
        },
        "feel": {
            "error": "Cevaplarınıza göre hissetme puanınız mevcut değil. "
        },
        "survey": {
            "requiredField": "* bu alan zorunludur"
        },
        "score_info_title": "Puanım ne anlama geliyor?",
        "company_average_info": "Şirketimdeki ortalama",
        "demographic_average_info": "Demografimdeki ortalama",
        "score": "İyilik hali puanı",
        "table": {
            "what_it_means": "Ne anlama geliyor?",
            "score": "Puan"
        },
        "updated": "Güncellendi",
        "label": {
            "excellent": "Mükemmel",
            "very_good": "Çok iyi",
            "good": "İyi",
            "fair": "Makul",
            "poor": "Zayıf"
        },
        "activity": {
            "eat": "Yeme Aktivitesi 1, Yeme Aktivitesi 2, Yeme Aktivitesi 3",
            "move": "Hareket Aktivitesi 1, Hareket Aktivitesi 2, Hareket Aktivitesi 3",
            "feel": "Hissetme Aktivitesi 1, Hissetme Aktivitesi 2, Hissetme Aktivitesi 3"
        },
        "score_info_screen": "Puanım nasıl hesaplanır?",
        "details": "Ayrıntılar",
        "activities": "Aktiviteler",
        "improveCategoryScore": "%{category} puanımı iyileştir",
        "meaning": {
            "heading": "Puan hesaplama"
        },
        "score_button": {
            "meaning": "Bu puan ne anlama geliyor?"
        },
        "improve": "Önerilen amaçlara bakın",
        "score_text": {
            "demographic": "Yaşınız ve cinsiyetiniz için ortalama puan:",
            "company": "ve şirketinizdeki ortalama puan:"
        },
        "scoreHigher": "şu ortalamadan daha yüksek:",
        "scoreLower": "şu ortalamadan daha düşük:",
        "settedGoals": {
            "noGoals": "Hiçbir amaç belirlenmedi",
            "one": "1 amaç belirlendi",
            "n": "%{count} amaç belirlendi"
        },
        "yourScoreIsPoor": "%{category} puanınız zayıf",
        "unlock": {
            "title": "İyilik hali puanınızın kilidini açın",
            "description": "Genel sağlık durumunuzun, aynı demografik gruptaki diğer kişilere kıyasla nasıl olduğunu öğrenmek için kısa bir anketi tamamlayın."
        },
        "browseAndSet": "Mevcut amaçlarınız bittikten sonra, yeni amaçlara göz atabilir ve yeni amaçlar belirleyebilirsiniz.",
        "excellent": {
            "desc1": "Olağanüstü sağlıklı yaşam tarzı",
            "desc2": "Çok düşük sağlık riski"
        },
        "veryGood": {
            "desc1": "Çok sağlıklı bir yaşam tarzı",
            "desc2": "Düşük sağlık riski"
        },
        "good": {
            "desc1": "Sağlıklı yaşam tarzı",
            "desc2": "Ortalama sağlık riski"
        },
        "fair": {
            "desc1": "Biraz sağlıklı yaşam tarzı",
            "desc2": "Ortalamanın üzerinde sağlık riski"
        },
        "poor": {
            "desc1": "Yüksek sağlık riski",
            "desc2": "Daha fazla günlük hareket önerilir",
            "desc3": "Daha fazla günlük harekete ihtiyaç var"
        },
        "calculateScore": {
            "description": "İyilik hali anketini tamamladığınızda, yanıtlarınız sizin yaşınızdaki ve cinsiyetinizdeki insanlardan gelen milyarlarca veri değişkeni kullanılarak analiz edilir. Hesaplama ayrıca %{programName} içinde takip ettiğiniz aktiviteyi de hesaba katar. \n \nİylik hali puanınız düzenli olarak güncellenir. Böylece zaman içinde değiştiğini görebilirsiniz."
        },
        "improveYourScore": "Puanınızı iyileştirme"
    },
    "challengerCount": "%{num} meydan okuyucu",
    "team_name": "Ekip adı",
    "syncingDeviceToast": {
        "danger": {
            "message": "Eyvah… %{name} senkronizasyonu sırasında bir sorun yaşadık. Lütfen tekrar deneyin.",
            "title": "Senkronizasyon"
        },
        "success": {
            "title": "Senkronizasyon",
            "message": "%{name} başarıyla senkronize edildi. Aktiviteleriniz artık güncel."
        }
    },
    "allCompanyMembers": "Tüm şirket üyeleri",
    "allCompanyMembersTeam": "Tüm şirket üyeleri (Ekip)",
    "successfullyRedeemedItemForConfirmation": "Bu öğeyi başarıyla kullandınız ve %{email} adresine bir onay e-postası gönderildi.",
    "no_all_events_placeholder": "Görünüşe göre şu anda katılabileceğiniz hiçbir etkinlik yok. Neden bir tane oluşturmuyorsunuz?",
    "confirmDeleteAccount": "Hesabınızla ilişkili e-posta adresini girerek silme işlemini onaylayın",
    "deleteAccount": "Hesabı sil",
    "linkAccounts": "Bağlantılı hesapları yönetin",
    "titleSlug": {
        "icon_reward_text": "Uygun üyelerimiz, ortaklarımızdan alışveriş yaparak veya ekstra kapsamlarıyla Members' Choice Advantage diş hekiminde muayene olarak daha fazla puan kazanabilirler.",
        "icon_move_text": "Daha iyi uyumak veya sebze yemek gibi günlük sağlıklı tercihlerinizi takip etmek size Live Better Puanları kazandırabilir.",
        "icon_redeem_text": "Live Better, sağlıklarına yönelik hastane veya ek teminatları olan Medibank üyelerini ödüllendiriyor.",
        "icon_phone_text": "Kaydolun ve sağlık ile iyilik hali hediye kartları veya sağlık sigortanızda tasarruf gibi ödülleri kullanmaya başlayın. ",
        "wellness": "Sağlıklı yaşam dünyasına hoş geldiniz",
        "goals": "Amaçlarınıza ulaşın",
        "devices": "Yolunuzdan şaşmayın",
        "challenges": "Yarışmalar oluşturun",
        "celebrate": "Sosyal sağlık",
        "habits": "Sağlıklı alışkanlıklar edinin",
        "joinChallenge": "Yarışmaya katılın",
        "getSocial": "Sosyalleşin",
        "reward": "Daha sağlıklı bir yaşam sürmenin ödülünü alın.",
        "move": "Daha iyi hareket edin, daha iyi beslenin ve kendinizi daha iyi hissedin.",
        "phone": "Daha iyi yaşayın, daha iyi hissedin."
    },
    "viewProgress": {
        "goal": "Amaç ilerlemesini görüntüle",
        "challenge": "Yarışma ilerlemesini görüntüle",
        "progress": "İlerlemeyi görüntüle"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "Bu bilgilerin girilmesi isteğe bağlıdır, sizin yararınızadır ve size özeldir."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "Bu etkinlik için %{potentialBonusPoints} bonus %{customPoints} mevcuttur."
        },
        "modal": {
            "paragraph1": "Bu etkinliğe katılarak %{pointsName} bonus kazanacaksınız.",
            "paragraph2": "Tüm bonus %{pointsName} etkinlik tamamlandıktan sonra verilir. Katılmadığınız etkinlikler için bonus alacağınız olmaz."
        }
    },
    "EAP": {
        "contactInfo": "İletişim bilgileri",
        "doLater": "Bunu daha sonra yapacağım",
        "tellMore": "Daha fazla bilgi istiyorum",
        "contactMe": "Bana ulaşın",
        "title": "Çalışan ve aile yardım programı",
        "reachGoal": {
            "title": "Yardım mevcut",
            "description": "%{providerName} tarafından sağlanan Çalışan ve Aile Yardım Programınız (EFAP), iyilik hali hedeflerinize ulaşmanıza yardımcı olabilecek çeşitli sağlık koçluğu hizmetleri sunar. \n \nDaha fazla bilgi vermek için %{providerName} sizinle iletişime geçsin mi?"
        },
        "privacyPolicy": "%{provider} Gizlilik Politikası"
    },
    "HRIS": {
        "disclaimer": "Bu bilgiler otomatik olarak ayarlanır ve değiştirilemez"
    },
    "settingGoals": {
        "description": "Aynı anda önerilen 3 amaca odaklanmak başarı olasılığınızı artıracaktır.",
        "title": {
            "one": "1 amaç belirlediniz"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Hesap zaten farklı bir kullanıcıya bağlı",
            "lastAccountMessage": "Son bağlantılı hesabınızı kaldırmak istediğinizden emin misiniz? Kaldırdıktan sonra %{email} e-posta adresi ve yeni bir parola ile oturum açmalısınız.",
            "unlinkCorpAccountMessage": "Kurumsal bağlantılı hesabınızı kaldırmak istediğinizden emin misiniz? Kaldırdıktan sonra %{email} e-posta adresi ile tekrar oturum açmalısınız.",
            "alreadyLinked": "Hesap zaten bağlı",
            "unlinkMessage": "Bağlantılı bir hesabı kaldırmak istediğinizden emin misiniz?"
        },
        "sso": {
            "emailNotVerified": "E-posta adresiniz doğrulanmadı."
        },
        "signIn": {
            "dontHaveAccount": "Hesabınız yok mu?",
            "enterPIN": "Şirketinizin Program Tanımlama Numarasını girin",
            "dontKnowPIN": "PIN'inizi bilmiyor musunuz?",
            "pin": "PIN",
            "register": "Kaydolun",
            "pinDescription": "Kuruluşunuzun benzersiz Program Tanımlama Numarası'ndan (PIN) emin değilseniz program yöneticinizle iletişime geçin. PIN'iniz varsa ve bir sonraki adıma geçmekte zorluk çekiyorsanız support@sproutatwork.com adresine başvurun.",
            "keepMeTooltip": "Size kolaylık sağlamak için, bu kutu işaretlendiğinde oturumunuz 30 gün boyunca geçerli kalacaktır. Paylaşılan cihazlarda bu kutunun işaretini kaldırmanızı ve işiniz bittiğinde oturumu kapatmanızı öneririz."
        },
        "signUp": {
            "backToLogin": "Girişe geri dön",
            "termsOfService": "Hizmet koşulları",
            "privacyPolicy": "Gizlilik politikası"
        },
        "createYourAccount": "Hesabınızı oluşturun ",
        "setYourDetails": "Ayrıntılarınızı ayarlayın",
        "ModaHybridLogin": {
            "noAccessDashboard": "Üye Panosuna erişiminiz yok mu?",
            "signUpSSOButton": "Moda Üye Panosu üzerinden kaydolun",
            "noAccessDashboardWeb": "Üye Panosuna erişiminiz yoksa e-posta adresiniz ve parolanızla aşağıdan oturum açın.",
            "loginSSOButton": "Moda Üye Panosu üzerinden oturum açın"
        }
    },
    "entityHasBeenDeleted": "%{name} silindi",
    "track_challenge": {
        "message": {
            "manually": "Manuel olarak takip edin",
            "automatically": "%{appOrDeviceName} ile otomatik olarak takip edildi",
            "manuallyOrConnect": "Manuel olarak takip edin veya bir uygulamaya veya cihaza bağlanın",
            "manuallyAndBy": "%{appOrDeviceName} ile manuel ve otomatik olarak takip edin",
            "reconnectDevice": "Cihaz gerekli. Lütfen cihazınızı yeniden bağlayın",
            "manualAndAuto": "Manuel ve otomatik olarak takip edin",
            "trackedAutomatically": "Otomatik olarak takip edildi"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Kayıt işlemi yapılamıyor",
            "message": "Kullanıcı ayrıntıları ortaktan alınamıyor. Lütfen daha sonra tekrar deneyin"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "Bu %{goalName} için bir uygulama veya cihaz gereklidir.",
            "subTitle": "Lütfen bir uygulama veya cihaz bağlayın"
        }
    },
    "descriptionSlug": {
        "wellness": "Amaç belirlemenize, bağlantı kurmanıza ve yolunuzdan şaşmamanıza yardımcı olan sağlık topluluğuna katılın.",
        "goals": "Ne için çalıştığınızı bize bildirin. Önerilen amaçlarla oraya ulaşmanıza yardımcı olacağız.",
        "devices": "Fitness cihazınızı senkronize edin veya aktivitelerinizi kaydedin ve sağlıklı yaşam amaçlarınızı takip edin.",
        "challenges": "Dostça bir rekabet başlatın. Bir yarışma oluşturun ve başkalarını eğlenceye katılmaya davet edin.",
        "celebrate": "İş arkadaşlarınızla bağlantıda kalın ve başarılarınızı birlikte kutlayın.",
        "habits": "Puan kazanmak için sağlıklı yaşam aktivitelerinizi takip edin. Daha hızlı kazanmak için telefonunuza veya giyilebilir cihazınıza bağlayın.",
        "joinChallenge": "İş arkadaşlarınızla dostça rekabetlerde nasıl performans gösterdiğinizi görün.",
        "getSocial": "İş arkadaşlarınızla bağlantıda kalın ve başarılarınızı birlikte kutlayın.",
        "reward_text": "Günlük aktivitelerinizi ve kişisel yarışmalarınızı tamamlayarak puan kazanın.",
        "move_text": "İster mahallede bir yürüyüş, ister beş dakikalık bilinçli farkındalık çalışması veya sağlıklı beslenme olsun, ödüllendirileceksiniz.",
        "phone_text": "Puanlarınızı sigortanızda indirim ve harika fırsatlar için kullanın. Seçim sizin.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Özellik etkin değil",
        "checkAppVersion": {
            "message": "Uygulamanız güncel değil gibi görünüyor. Lütfen en son güncellemeyi yükleyin.",
            "button": "%{appName} uygulamasını güncelle"
        },
        "noConnection": {
            "title": "Ağ bağlantısı yok",
            "description": "Görünüşe göre internete bağlı değilsiniz. Bağlantınız olmadığı sürece uygulamayı tam olarak kullanamazsınız.",
            "button": "Tekrar dene"
        },
        "uploadPhotoText": "%{entityType} için bir fotoğraf ekleyin",
        "entities": {
            "community": "topluluk",
            "event": "etkinlik",
            "team": "ekip",
            "goal": "amaç",
            "challenge": "yarışma",
            "competition": "müsabaka"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Oturum açılamıyor",
            "resetPasswordHeading": "Parola Sıfırlaması Gerekiyor"
        },
        "signup": {
            "corporateOrOther": "Medibank üyesi değil misiniz? Yoksa kurumsal bir programın parçası mısınız?",
            "sign_up_here": "Buradan kaydolun ",
            "errorHeading": "Kayıt işlemi yapılamıyor",
            "areYouMedibankMember": "Medibank üyesi misiniz?",
            "isMedibankMember": "Üyeyim",
            "isNotMedibankMember": "Üye değilim"
        },
        "bpidExists": "Sağlanan e-posta adresi halihazırda bir Live Better kullanıcısı ile ilişkilendirilmiş. E-posta adresi benzersiz olmalıdır.",
        "generalError": "Hizmet şu anda kullanılamıyor"
    },
    "rewardsNoAvailableProducts": "Şu anda kullanılabilir ürün bulunmamaktadır.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "Takip etmek için hala vaktiniz var.",
            "no": "%{type} sona erdi"
        },
        "grace": "%{type} sona ermiş olabilir ancak unutulan aktiviteleri takip etmek için %{n} %{text} süreniz var",
        "notGrace": {
            "goal": "Hedefinizi tamamladığınız için tebrikler! Sağlığınıza dikkat etmek için yeni bir amaç belirleyerek aynen devam edin.",
            "competition": "Yarışmayı tamamladığınız için tebrikler! Başka bir yarışmaya katılarak veya kendi yarışmanızı oluşturarak ivmenizi koruyun."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Cihazınızı veya uygulamanızı bağlayın ve sorunsuz takibin keyfini çıkarın. Kimlik doğrulamanız, teknoloji ortağımız \"Sprout\"un verilerinizi %{appDeviceTitle} hesabınızdan güvenli bir şekilde aktarmasını sağlar."
    },
    "noTransactionsMessage": "Görünüşe göre herhangi bir işlem yapmamışsınız.",
    "noRedemptionsMessage": "Görünüşe göre herhangi bir kullanım işlemi yapmamışsınız.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Yarışmalara bireysel olarak veya ekip olarak katılabilirsiniz",
            "prompt": "Şu anda katılabileceğiniz bir yarışma yok. Neden bir tane oluşturmuyorsunuz?"
        },
        "createChallengeButton": "Bir yarışma oluşturun"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Etkinlikler yalnızca davetlilerin katılabileceği veya herkesin katılabileceği şekilde olabilir.",
            "button": "Bir etkinlik oluşturun"
        },
        "emptyEventsMessage": "Şu anda katılabileceğiniz bir etkinlik yok. Neden bir tane oluşturmuyorsunuz?"
    },
    "appnameLiveBetter": "Live Better",
    "appnameTelus": "Wellbeing",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "Belirlenmiş hiçbir amacınız yok.",
            "descriptionNoSet": "Bazı amaçlar belirleyerek iyilik hali puanınızı iyileştirin. Önerilen bir amaçla hızla başlayın, katalogdan seçin veya kendinizinkini oluşturun.",
            "descriptionSet": "Sizin için özel olarak hazırladığımız önerilen amaçlardan birini belirleyebilir, tüm kataloğa göz atabilir veya kendi amacınızı oluşturabilirsiniz.",
            "action_text": "Yeni bir amaç belirleyin",
            "heading_singular": "1 amaç daha belirleyebilirsiniz",
            "heading_plural": "%{number} amaç daha belirleyebilirsiniz"
        },
        "heading": "Kişisel amaçlar",
        "single": "Kişisel amaç"
    },
    "settingGoal": {
        "yourGoal": "Size ait %{units}",
        "yourGoalDescription": "Yolculuğunuz başladı. Aşağıdaki %{units} ayarlanacak ve hemen başlayacak.",
        "selectedGoals": "Seçilmiş amaçlar",
        "recommendedDescription": {
            "maximumSet": "Maksimum sayıda amaç belirlediniz. Mevcut amaçlarınız bittikten sonra, yeni amaçlara göz atabilir ve yeni amaçlar belirleyebilirsiniz.",
            "maximumSetTitle": "%{count} amaç belirlediniz"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "Aktivite kaldırıldı",
            "info": "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
            "danger": "Bir şeyler ters gitti. Lütfen tekrar deneyin."
        },
        "plural": {
            "success": "Aktiviteler kaldırıldı",
            "info": "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
            "danger": "Bir şeyler ters gitti. Lütfen tekrar deneyin."
        },
        "success": "Aktivite kaldırıldı",
        "info": "Aktivite kaldırılmadı. Lütfen tekrar deneyin.",
        "danger": "Aktivite kaldırılmadı. Lütfen tekrar deneyin."
    },
    "participants": "Katılımcılar",
    "members": "Üyeler",
    "timeSittingInformationOld": "Kılavuzda şunlar öneriliyor: \n- Uzun süre oturarak geçirilen süreyi en aza indirin. \n- Uzun süre oturmayı mümkün olduğunca sık aralıklarla bölün.",
    "timeSittingInformation": {
        "title": "Kılavuzda şunlar öneriliyor:",
        "list": "- Uzun süre oturarak geçirilen süreyi en aza indirin. \n- Uzun süre oturmayı mümkün olduğunca sık aralıklarla bölün."
    },
    "activityLevelInformationOld": "Kılavuzda şunlar öneriliyor: \n- Her hafta tercihen her gün aktif olun. \n- Her hafta 150 dakikadan fazla orta yoğunlukta fiziksel aktivite yapın. \n- Her hafta en az 2 gün kas güçlendirme aktiviteleri yapın.",
    "activityLevelInformation": {
        "title": "Kılavuzda şunlar öneriliyor:",
        "list": "- Her hafta tercihen her gün aktif olun. \n- Her hafta 150 dakikadan fazla orta yoğunlukta fiziksel aktivite yapın. \n- Her hafta en az 2 gün kas güçlendirme aktiviteleri yapın."
    },
    "viewGuidelines": "Kılavuzu görüntüle",
    "corporateAccountLink": {
        "verification": {
            "title": "İş e-posta adresinizi doğrulayın",
            "description": "Bağlantı sürecini başarıyla tamamlamak için iş e-posta adresinizi doğrulamanız gerekecektir. Lütfen şu adrese gönderilen talimatları izleyin:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Arkadaşlarınızı ve ailenizi bulun",
        "findFriends&Family": "Arkadaşlarınızı ve ailenizi bulun",
        "tapToAddFriendsAndFamily": "Arkadaşlara ve aileye eklemek için dokunun",
        "addedFriendsAndFamily": "Arkadaşlara ve aileye eklendi",
        "whoYouAreLookingFor": "Aradığınız kişiyi bulamadınız mı?",
        "inviteWithEmail": "E-posta ile davet edin",
        "sentInvitations": "Gönderilen davetler",
        "foundPerson": "Bu kişiyi eşleşen bir e-posta adresiyle bulduk",
        "youAreBoth": "İkiniz de %{entityName} içindesiniz",
        "youAreBothMore": "%{n} kişi ile birlikte ikiniz de %{entityName} içindesiniz",
        "noFriendsAndFamilyAdded": "Görünüşe göre henüz eklediğiniz herhangi bir arkadaşınız veya aile üyeniz yok.",
        "sendInvitation": "Davet gönder",
        "youHaveNoSentInvitations": "Hiçbir davet göndermediniz",
        "toast": {
            "success_title": "Davet gönderildi",
            "success_description": "%{invite_email} daveti gelen kutusunda görecek",
            "danger_title": "Davet başarısız oldu",
            "danger_description": "Lütfen daha sonra tekrar deneyin"
        },
        "email": {
            "invalid_email": "Lütfen geçerli bir e-posta adresi girin"
        },
        "inviteOthers": "Başkalarını davet edin",
        "searchForSomeone": "Birini arayın",
        "searchForOthersToInvite": "Davet edilecek diğer kişileri arayın",
        "programNameOnly": {
            "title": "Yalnızca %{programName}",
            "description": "Bu %{entityType} yalnızca %{programName} programının bir parçası olan kişiler tarafından kullanılabilir"
        },
        "domainCannotBeUsed": "Bu etki alanı %{programName} ile kullanılamaz",
        "actionSearchByEmail": "Aradığınız kişiyi bulamazsanız e-posta ile davet edin",
        "send": "Gönder",
        "addEmailToList": "Listeye e-posta ekleyin",
        "toBeSent": "Gönderilecek davetler",
        "noInvitationsToBeSent": "Davet yok",
        "removeEmailConfirmation": "Bu e-posta adresini listeden kaldırmak istediğinizden emin misiniz?",
        "yes": "Evet",
        "no": "Hayır",
        "foundByEmail": "Bu kişiyi eşleşen bir e-posta adresiyle bulduk",
        "addToFriendsAndFamily": "Arkadaşlara ve aileye ekle",
        "alreadyAddedEmail": "Bu e-posta adresini listeye zaten eklediniz"
    },
    "pointsCurrencyAdditionalInfo": "%{points_name} ve seviyeleriniz her %{period} yeniden başlar. Takip edilen tüm aktiviteleriniz dönemdeki genel seviyenize katkıda bulunur.",
    "rankLabel": "Sıralama",
    "leaderboards": {
        "loadingLabel": "Puan tabloları yükleniyor... Bu işlem birkaç dakika sürebilir. Herkesin aktif olmaya çalıştığını görüyoruz."
    },
    "feeds": {
        "emptyListHomePage": "Henüz gösterilecek gönderi yok. Daha fazla gönderi göstermek için akışı ayarlamayı deneyin.",
        "viewingPostsFrom": "Şuradan gönderiler görüntüleniyor:",
        "postActivity": "Aktiviteleriniz hakkında yorum veya fotoğraf ekleyin.",
        "indicatorLoader": {
            "defaultTitle": "Yenileniyor...",
            "successfulLoadedTitle": "Senkronize edildi ve yenilendi..."
        },
        "inapropriateTextError": {
            "message": "Mesajınızdaki içerik uygunsuz olabilir. Lütfen daha dostça bir dil kullanmayı deneyin."
        },
        "postImageError": {
            "title": "Üzgünüz, bunu yayınlayamıyoruz",
            "message": "Eklediğiniz resim uygunsuz olabilir. Lütfen başka bir resim deneyin."
        }
    },
    "syncModal": {
        "connect": {
            "title": "%{name} bağlanıyor",
            "description": "%{name} verilerinizi hesabınıza bağlamak için aşağıdaki adımları izleyin:",
            "firstStep": "%{appName} mobil uygulamasını şu adresten indirin ve yükleyin: %{storeName}",
            "fourthStep": "%{name} ile bağlanmayı seçin",
            "fifthStep": "İstendiğinde, %{appName} ile senkronize edilecek sağlık ölçümlerini seçin ve \"Bitti\"ye basın",
            "additionalInfo": "Lütfen Health uygulamasından senkronizasyonu tetiklemek için %{appName} uygulamasının açılması gerektiğini unutmayın. Uygulamayı açık tutmanız gerekmese de senkronizasyonun tamamlanması ve aktivite günlüğünüzde görünmesi bir saat sürebilir."
        },
        "title": "%{name} senkronize ediliyor",
        "description": "%{name} verilerinizi hesabınızla senkronize etmek için aşağıdaki adımları izleyin:",
        "steps": {
            "one": "Telefonunuzda %{appName} uygulamanızda oturum açın",
            "two": "Profilinizdeki Uygulamalar ve Cihazlar bölümünü açın",
            "three": "%{name} yanındaki senkronizasyon düğmesine basın",
            "iPhone": "iPhone'unuzda %{appName} uygulamanızda oturum açın"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "İş hesabı",
            "message": "Hesap başarıyla bağlandı"
        },
        "danger": {
            "message": "Hesap bağlanırken hata oluştu"
        },
        "conflict": {
            "message": "Hesap zaten farklı bir kullanıcıya bağlı"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "İş hesabı",
            "message": "Hesabın bağlantısı başarıyla kesildi"
        },
        "danger": {
            "title": "Hesapları bağla",
            "message": "Hesap bağlantısı kesilirken hata oluştu"
        }
    },
    "earnMoreWithPartners": "Ortaklarla daha fazla kazanın",
    "connectPartnersToEarnByShopping": "Hesaplarınızı bağlayın ve %{program_name} ortaklarından alışveriş yaparak daha fazla %{unit_type} kazanın.",
    "viewAllPartners": "Tüm ortakları görüntüle",
    "myPartnerMemberships": "Ortak üyeliklerim",
    "linkAccount": "Üyeliği bağla",
    "linkToPartner": "Ortağa bağla",
    "linkingError": "Hesabınız bağlanırken bir sorun oluştu. Lütfen tekrar deneyin.",
    "linkPending": "Bağlantı bekleniyor",
    "unlinkAccount": "Hesabın bağlantısını kaldır",
    "linkedToPartnerName": "%{partner_name} ile bağlantılı",
    "linked": "Bağlantılı",
    "permission": {
        "facebookTitle": "Facebook ile kaydolun",
        "googleTitle": "Google ile kaydolun",
        "facebookDescription": "Facebook'a kaydolurken teknoloji ortağımız \"Sprout\"a kimliğinize erişme ve %{programName} hesabınızı oluşturma izni vermeniz gerekecektir.",
        "googleDescription": "Google'a kaydolurken teknoloji ortağımız \"Sprout\"a kimliğinize erişme ve %{programName} hesabınızı oluşturma izni vermeniz gerekecektir.",
        "camera": {
            "title": "Kamera erişimi",
            "description": "Fotoğraf çekmek için kamera erişimi gereklidir. iPhone ayarlarında, %{appName} öğesine dokunun ve Kamerayı açın. \n \nKaydedilmemiş değişiklikleri kaybedebileceğinizi lütfen unutmayın."
        },
        "notNow": "Şimdi değil",
        "openSettings": "Ayarları aç",
        "photos": {
            "title": "Lütfen fotoğraf erişimine izin verin",
            "description": "Bu, kitaplığınızdaki fotoğrafları paylaşmanıza ve fotoğrafları albüme kaydetmenize olanak tanır. iPhone ayarlarında, %{appName} öğesine dokunun ve Fotoğraflar'ı Oku ve yaz olarak değiştirin. \n \nKaydedilmemiş değişiklikleri kaybedebileceğinizi unutmayın."
        }
    },
    "firstNameContainsSpecialChar": "Adınız yalnızca İngilizce harfleri, tire ve kesme işaretlerini içerebilir",
    "lastNameContainsSpecialChar": "Soyadınız yalnızca İngilizce harfleri, tire ve kesme işaretlerini içerebilir",
    "goToPartnerSite": "Ortak sitesine git",
    "noPartnersFound": "Hiçbir ortak bulunamadı",
    "noLinkedPartners": "Bağlantılı ortak yok",
    "noPartnersInCategory": "Kategoride ortak yok",
    "partnerAccountPendingVerification": "Hesap doğrulaması bekleniyor",
    "shopWithPartner": "Ortaktan alışveriş yapın",
    "shopWithPartnerName": "%{partner_name} adlı ortaktan alışveriş yapın",
    "linkToPartnerName": "%{partner_name} bağlantısı",
    "earnPartnerMembershipIdentifier": "Üyelik tanımlayıcısı",
    "earnPartnerAccountPendingAddLink": "Üyeliğiniz bağlanıyor. Bu işlemin tamamlanması birkaç gün sürebilir.",
    "earnPartnerAccountPendingRemoveLink": "Üyeliğinizin bağlantısı kaldırılıyor. Bu işlemin tamamlanması birkaç gün sürebilir.",
    "linkStatusUpdating": "Bağlantı durumu güncelleniyor",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "İlk aktivitelerinizi eklediğiniz için tebrikler! \n \nİsterseniz bugün ve diğer günler için daha fazla aktivite ekleyebilirsiniz. Bugünkü aktiviteleri tamamladığınızda ve takip edilecek başka bir şey kalmadığında bir sonraki ekrandaki",
            "description2": "öğesine dokunun."
        },
        "listTitle": "Şurada takip edilen aktiviteler:",
        "dots": {
            "tracked": "Bugün takip edilen aktiviteler",
            "added": "Aktiviteler eklendi ve gönderilmeyi bekliyor"
        },
        "trackedActivitiesFor": "%{date} için takip edilen aktiviteler",
        "activityTracking": "Aktivite takibi",
        "addedPending": "Eklendi (gönderilmeyi bekliyor)",
        "search": {
            "description1": "Mevcut aktiviteleri görmek veya belirli bir aktiviteyi aramak için",
            "description2": "öğesine dokunun"
        },
        "addActivity": "Aktivite ekle",
        "addAnotherActivity": "Başka bir aktivite ekle"
    },
    "rewardsBalance": "%{currencyName} bakiyesi: %{points}",
    "membershipIdentifierRequiredError": "Bağlantı kurmak için üyelik tanımlayıcınız gereklidir",
    "incorrectValueInRange": "Lütfen %{min} ile %{max} arasında bir değer girin",
    "joinTeam": {
        "title": "Ekibe katıl",
        "createInsteadText": "Bu yarışmaya katılmak için bir ekibe katılın veya bir ekip oluşturun"
    },
    "teamRank": "Ekip sıralaması",
    "teamScore": "Ekip puanı",
    "appsDevices": {
        "infoText": "Bir uygulama veya cihaz eklerken, teknoloji ortağımız Sprout Wellness Solutions, Inc.'in sağlık verilerinize erişmesine yetki vermeniz istenecektir.",
        "connectModal": {
            "title": "Yetkilendirme",
            "paragraph1Part1": "Teknoloji ortağımız",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.'in",
            "paragraph1Part3": "sağlık verilerinize erişmesine yetki vermeniz istenecektir.",
            "paragraph2Desc1": "Verdiğiniz yetki sayesinde",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "güvenli bir şekilde",
            "paragraph2Desc4": "verilerinizi",
            "paragraph2Desc5": "ile senkronize edebilecek ve daha fazla %{pointsName} kazanmanıza yardımcı olacaktır."
        },
        "statusAlert": {
            "connectMessage": "Bir uygulama veya aktivite takip cihazı bağlayın ve aktivite senkronizasyonunu ve takibi kolaylaştırın",
            "connectAction": "Bir uygulama veya cihaz bağlayın",
            "errorMessage": "Bağlı uygulamalarınızın veya cihazlarınızın bazıları senkronize edilemiyor",
            "warningMessage": "Bağlı uygulamalarınızın veya cihazlarınızın bazılarında bağlantı sorunu olabilir",
            "errorAction": "Bu hatayı düzeltin",
            "warningAction": "Bu uyarıyı düzeltin",
            "syncingError": "Senkronizasyon hatası",
            "syncingIssue": "Senkronizasyon sorunu"
        },
        "deviceDetails": {
            "warningMessage": "Bu uygulama veya cihaz senkronizasyonda sorun yaşıyor",
            "errorMessage": "Bu uygulama veya cihaz senkronize edilemiyor",
            "warningAction": "Uyarıyı iptal et",
            "noActivities": "Son 7 günde hiçbir %{deviceName} aktivitesi %{programName} ile senkronize edilmedi. \n \nAktivitelerin %{deviceName} ile takip edildikten sonra burada görünmesi bir saat kadar sürebilir. \n \nBağlı başka bir uygulamanız veya cihazınız varsa ve diğer uygulama veya cihaz tarafından daha fazla adım takip edilmişse aktiviteyi orada göreceksiniz. Aksi takdirde, %{deviceName} bağlantısını kesip yeniden bağlanmayı deneyin. Kimlik doğrulaması yapmanız veya izin vermeniz istenirse, aktivite verilerini etkinleştirdiğinizden ve kimlik doğrulaması için kullandığınız hesabın, aktiviteleri izlemek için kullanılan hesap ile aynı olduğundan emin olun. Daha fazla bilgi edinmek için sorun giderme adımlarına göz atın.  "
        },
        "troubleshooting": "Sorun giderme",
        "deviceItem": {
            "error": "Bağlantı hatası",
            "warning": "Bağlantı uyarısı",
            "unableToSync": "Senkronize edilemiyor"
        },
        "platformDevice": {
            "defaultApp": "Cihazınızın varsayılan sağlık uygulaması",
            "continueMore": "Daha fazla uygulama ve cihaz için devam edin"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Arkadaşlar ve aile hakkında daha fazla bilgi edinin",
        "learnModal": {
            "title": "Arkadaşlar ve aile hakkında",
            "description": "Birini arkadaşlarınıza ve ailenize ekledikten sonra, %{programName} üzerindeki gönderilerinizi yalnızca onlarla paylaşmayı seçebilirsiniz. \n \nAyrıca %{programName} üzerinde gördüğünüz gönderileri, eğer herkese veya size göndermişlerse yalnızca arkadaşlarınız ve aile listenizdeki kişilerle paylaşacak şekilde filtreleyebilirsiniz.",
            "description_line1": "Birini arkadaşlarınıza ve ailenize ekledikten sonra, %{programName} üzerindeki gönderilerinizi yalnızca onlarla paylaşmayı seçebilirsiniz.",
            "description_line2": "Ayrıca %{programName} üzerinde gördüğünüz gönderileri, eğer herkese veya size göndermişlerse yalnızca arkadaşlarınız ve aile listenizdeki kişilerle paylaşacak şekilde filtreleyebilirsiniz.",
            "whatIconsMean": "Simgeler ne anlama geliyor?",
            "canAdd": "Ekle",
            "added": "Eklendi"
        },
        "searchDescription1": "Arkadaşlarınıza ve ailenize eklemek istediğiniz kişileri arayın.",
        "searchDescription2": "Aradığınız kişiyi göremiyor musunuz? E-posta ile katılmaya davet edin.",
        "friends&Family": "Arkadaşlar ve aile",
        "managingTour": {
            "title": "Arkadaşları ve aileyi yönetme",
            "body": "Birini arkadaşlarınızdan ve ailenizden kaldırmak istiyorsanız şu simgeye dokunun:"
        },
        "removeOption": "Arkadaşlar ve aileden kaldırın",
        "inviteDescription1": "Arkadaşlarınızı ve ailenizi arayın.",
        "inviteDescription2": "Aradığınız kişiyi bulamadınız mı?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "Sadece arkadaşlarınız ve ailenizle paylaştığınız gönderiler artık %{userFirstName} tarafından görülemeyecek."
        }
    },
    "skipAll": "Tümünü atla",
    "smallMin": "minimum",
    "eap": {
        "skipModal": {
            "title": "Emin misiniz?",
            "description": "İhtiyaç duyduğunuzda profilinizden Çalışan ve Aile Yardım Programı'na her zaman ulaşabilirsiniz."
        },
        "contact": {
            "whatIsBestNumber": "Sizinle en rahat iletişime geçilebilecek numara hangisi?",
            "whatIsBestTime": "Sizinle iletişime geçilebilecek en uygun zaman nedir?",
            "morning": "Sabah",
            "afternoon": "Öğleden sonra",
            "evening": "Akşam",
            "additionalDetails": "Sizinle iletişime geçilmesini istediğiniz tarih\/saat hakkında ek bilgiler",
            "message": "%{weekDay} günü %{phoneNumber} numaralı telefondan bana ulaşın. Ek bilgi: %{additional}",
            "description": "Not: Çalışma saatlerinizin dışında bir zaman seçmenizi ve özel bir görüşme yapabileceğiniz bir yer seçmenizi önemle tavsiye ederiz. Lütfen saat diliminizi ekleyin."
        },
        "phoneNumber": {
            "empty": "Bu alan boş olamaz",
            "missingDigits": "Telefon numarası en az 4 haneli olmalıdır"
        },
        "myEAP": "Çalışan ve aile yardım programım"
    },
    "healthSurveySkipAllTitle": "İ̇yilik hali anketini atla",
    "healthSurveySkipAllAlert": "İyilik hali anketinin kalan tüm sorularını atlamak istediğinizden emin misiniz?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Çalışan ve aile yardım programı",
            "message": "Lütfen telefon numaranızı ve en uygun iletişim saatinizi belirtin"
        }
    },
    "allMyChallenges": "Yarışmalarım",
    "invitedChallenges": "Davetler",
    "companyChallenges": "Şirket yarışmaları",
    "completedChallengesEmpty": "Görünüşe göre henüz hiçbir yarışma tamamlamadınız.",
    "myChallengesEmpty": "Görünüşe göre henüz hiçbir yarışmaya katılmadınız.",
    "allChallengesEmpty": "Hiçbir yarışma yok.",
    "startsToday": "Bugün başlıyor",
    "startedDaysAgo": "%{dayCount} gün önce başladı",
    "startsInDays": "%{dayCount} gün içinde başlıyor",
    "privacyOn": "Kapalı",
    "privacyOff": "Açık",
    "dashboard": {
        "viewLeaderboard": "Puan tablosunu görüntüle",
        "timePeriodProgress": "Bu %{period} ilerlemeniz",
        "howToEarn": "Puan Nasıl Kazanılır?"
    },
    "privacyChangeConfirmationMessage": "Gizlilik değiştirilsin mi?",
    "privacySettingsTitle": "Gizlilik",
    "privacySettingsDescription": "Fotoğrafınızın, adınızın ve profilinizin diğer kullanıcılar tarafından görülebilirliğini kontrol edebilirsiniz. ",
    "mainLeaderBoardSettingsTitle": "?Genel puan tablosu",
    "challengeLeaderBoardSettingsTitle": "?Yarışma puan tablosu",
    "managePrivacySettingUrlTitle": "Gizlilik ayarlarını yönetme",
    "onboardingFamilyPrivacySettingsMessageOn": "Arkadaşlar ve aile arama sonuçlarında görünürsünüz. Kendinizi arama sonuçlarından gizlemeyi seçebilirsiniz.",
    "onboardingFamilyPrivacySettingsMessageOff": "Gizlilik ayarlarınıza göre şu anda arkadaşlar ve aile arama sonuçlarında gizleniyorsunuz.",
    "challengeInvitationPrivacySettingsMessageOn": "Yarışma daveti arama sonuçlarında görünürsünüz. Kendinizi arama sonuçlarından gizlemeyi seçebilirsiniz.",
    "challengeInvitationPrivacySettingsMessageOff": "Gizlilik ayarlarınıza göre şu anda yarışma daveti arama sonuçlarında gizleniyorsunuz.",
    "challengeParticipationPrivacySettingsMessageOn": "Bu yarışmanın katılımcısı olarak listelendiniz. Yarışma katılımcısı olduğunuzun gizlenmesini seçebilirsiniz.",
    "challengeParticipationPrivacySettingsMessageOff": "Gizlilik ayarlarınıza göre şu anda katılımcı listesinde gizleniyorsunuz.",
    "communityInvitationPrivacySettingsMessageOn": "Topluluk daveti arama sonuçlarında görünürsünüz. Kendinizi arama sonuçlarından gizlemeyi seçebilirsiniz.",
    "communityInvitationPrivacySettingsMessageOff": "Gizlilik ayarlarınıza göre şu anda topluluk daveti arama sonuçlarında gizleniyorsunuz.",
    "communityParticipationPrivacySettingsMessageOn": "Bu topluluğun üyesi olarak listelendiniz. Topluluklarınızın üyesi olduğunuzun gizlenmesini seçebilirsiniz.",
    "communityParticipationPrivacySettingsMessageOff": "Gizlilik ayarlarınıza göre şu anda üye listesinde gizleniyorsunuz.",
    "eventInvitationPrivacySettingsMessageOn": "Etkinlik daveti arama sonuçlarında görünürsünüz. Kendinizi arama sonuçlarından gizlemeyi seçebilirsiniz.",
    "eventInvitationPrivacySettingsMessageOff": "Gizlilik ayarlarınıza göre şu anda etkinlik daveti arama sonuçlarında gizleniyorsunuz.",
    "eventParticipationPrivacySettingsMessageOn": "Bu etkinliğin katılımcısı olarak listelendiniz. Etkinliklerinizin katılımcısı olduğunuzun gizlenmesini seçebilirsiniz.",
    "eventParticipationPrivacySettingsMessageOff": "Gizlilik ayarlarınıza göre şu anda katılımcı listesinde gizleniyorsunuz.",
    "mainLeaderboardPrivacySettingsMessageOn": "Genel puan tablolarında gösteriliyorsunuz. Kendinizi gizlemeyi seçebilirsiniz. Böylece diğerleri genel puan tablolarını görüntülediğinde sıralamanız, resminiz ve adınız görünmez.",
    "mainLeaderboardPrivacySettingsMessageOff": "Gizlilik ayarlarınıza göre şu anda, başkaları genel puan tablolarını görüntülerken gizleniyorsunuz.",
    "challengeLeaderboardPrivacySettingsMessageOn": "Yarışma puan tablolarında gösteriliyorsunuz. Kendinizi gizlemeyi seçebilirsiniz. Böylece diğerleri yarışma puan tablolarını görüntülediğinde sıralamanız, resminiz ve adınız görünmez.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Gizlilik ayarlarınıza göre şu anda, başkaları yarışma puan tablolarını görüntülerken gizleniyorsunuz.",
    "thumbsUpConfirmationTitle": "Beğeni",
    "thumbsUpConfirmationDescriptionline1": "Tebrikler, ilk beğeninizi göstererek başkalarını cesaretlendireceksiniz.",
    "thumbsUpConfirmationDescriptionline2": "Bu gönderiyi beğenen kişilerin listesine ekleneceksiniz ve diğerleri resminizi, adınızı görebilecek ve profilinizi görüntüleyebilecek.",
    "thumbsUpConfirmationButtonOk": "Beğeni",
    "commentToActionInfoTitle": "Başkaları ne görüyor?",
    "commentToActionMessage": "Yorum yaptığınızda başkaları resminiz ile adınızı görebilir ve profilinizi görüntüleyebilir.",
    "postToActionTitle": "Bu gönderiyi kimler görüyor?",
    "postToActionMessageLine1": "Bir gönderi oluşturduğunuzda, onu kimlerin görebileceğini kontrol edebilir ve hatta yalnızca kendinize gönderi yayınlayabilirsiniz.",
    "postToActionMessageLine2": "Başkalarıyla paylaştığınız gönderilerde resminiz ile adınız görünecek ve başkaları profilinizi görüntüleyebilecek",
    "privateUsersDescriptionChallenge": "Bu katılımcılar kendilerini listeden gizlediler",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} gizli",
    "privateUsersLastNamePlaceHolderChallenge": "katılımcılar",
    "privateUsersDescriptionEvent": "Bu katılımcılar kendilerini listeden gizlediler",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} gizli",
    "privateUsersLastNamePlaceHolderEvent": "katılımcılar",
    "privateUsersDescriptionCommunity": "Bu üyeler kendilerini listeden gizlediler",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} gizli",
    "privateUsersLastNamePlaceHolderCommunity": "üyeler",
    "noPrivacySettings": "Gizlilik ayarı yok",
    "linkToPartnerNameWebsite": "%{partner_name} web sitesi üzerinden bağlantı",
    "linkToPartnerWebsiteUrl": "Ortak web sitesi URL'si",
    "start_end_time": "Başlangıç ve Bitiş zamanı:",
    "joinCreateTeamPrivacyDisclaimer": "Gizlilik Ayarlarınızı Gizli olarak değiştirmiş olsanız bile, resminiz, adınız ve profiliniz bir yarışmada ekibinizi görüntüleyen herkes tarafından görülebilir.",
    "carouselInstructions": {
        "swipe": "Tüm amaç ve yarışmalarınızı görmek için kartları kaydırın.",
        "click": "Tüm amaç ve yarışmalarınızı görmek için kartlara tıklayın."
    },
    "achieved": "Başarıldı",
    "hours": "saat",
    "createCommunityFlow": {
        "navigatorTitle": "Topluluk oluştur",
        "stepType": {
            "title": "Topluluk görünürlüğü",
            "subTitle": "Topluluğu kimler görebilecek ve topluluğa kimler katılabilecek?",
            "privateName": "Özel",
            "publicName": "Genel",
            "privateDescription": "Yalnızca davet ettiğiniz kişiler topluluğu görebilir veya topluluğa katılabilir",
            "publicDescription": "Herkes bu topluluğu görebilir ve bu topluluğa katılabilir"
        },
        "stepName": {
            "title": "Topluluğunuza isim verin",
            "subTitle": "Topluluğunuza, insanların topluluğunuzun ne hakkında olduğunu anlamalarını sağlayacak bir isim verin.",
            "namePlaceholder": "Topluluk adı",
            "noFieldsTitle": "İsim",
            "noFieldsMessage": "İsim verilmedi"
        },
        "stepDescription": {
            "title": "Topluluğunuz hakkında",
            "subTitle": "Topluluğunuzun ne hakkında olduğunu başkalarına anlatın.",
            "descriptionPlaceholder": "Açıklama (isteğe bağlı)",
            "noFieldsTitle": "Açıklama",
            "noFieldsMessage": "Hiçbir açıklama yapılmadı"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Bir fotoğraf ekleyin"
        },
        "stepJoin": {
            "title": "Benzer topluluklar bulduk",
            "subTitle": "Bunun yerine bu topluluklardan birine katılmak ister misiniz?"
        },
        "createNew": "Yeni topluluk oluştur"
    },
    "challengeCard": {
        "allActivities": "Şuradaki tüm aktiviteler:",
        "category": "kategori"
    },
    "myLinkedPartners": "Bağlantılı ortaklarım",
    "leaderboardPosition": "Genel puan tablosu konumu",
    "remainingInChallenge": "yarışmada kalan",
    "todays_progress": "Bugünkü ilerleme",
    "this_weeks_progress": "Bu haftanın ilerlemesi",
    "this_months_progress": "Bu ayın ilerlemesi",
    "achievement": "başarı",
    "challengeCardHeader": {
        "challenge": "Yarışma",
        "recommended_personal_goals": "Önerilen kişisel amaç",
        "personal_goal": "Kişisel amaç",
        "competition": "Müsabaka",
        "recommended_goals": "Önerilen amaç",
        "team_competition": "Ekip müsabakası",
        "team": "Ekip"
    },
    "MyMedibank": "Medibank'ım",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "Bitiş zamanı başlangıç zamanından daha erken olamaz",
    "company": "Şirket",
    "lessThan1DayRemain": "1 günden az",
    "lessThan1HourRemain": "1 saatten az",
    "remainingToday": "bugün kalan",
    "periodEndsDateAndTime": "Dönem %{date}, %{time} tarihinde sona eriyor",
    "moreToGo": "Başlayacak %{n} %{unit} daha var",
    "reachedYourGoal": "%{period} amacınıza ulaştınız.",
    "reachedYourGoalToday": "Bugün amacınıza ulaştınız.",
    "editProfileItemCorrectRange": "Lütfen minimum değer %{min} ile maksimum değer %{max} arasında geçerli bir %{itemName} değeri sağlayın",
    "invalidUrl": "Geçersiz URL",
    "activityLogChanged": {
        "success": "Aktivitedeki değişiklikler kaydedildi",
        "info": "Bir şeyler ters gitti... Lütfen tekrar deneyin.",
        "danger": "Bir şeyler ters gitti... Lütfen tekrar deneyin."
    },
    "discardAlert": {
        "createChallenge": "Şunu iptal etmek istediğinizden emin misiniz: %{challengeType}?",
        "inviteByEmail": "Değişiklikleri iptal etmek istediğinizden emin misiniz?",
        "createTeam": "Bu ekibin oluşturulmasını iptal etmek istediğinizden emin misiniz?",
        "cancel": "İptal et",
        "confirm": "Evet, iptal et"
    },
    "entityInvalidNameError": "%{entity} adı yalnızca sayılardan veya dize değerlerinden oluşmalıdır ve boş olamaz",
    "accept": "Kabul et",
    "sync_now": "Şimdi senkronize et",
    "reconnect_device": "Yeniden bağlan",
    "supported_activities": "Desteklenen aktiviteler",
    "recentlySynced_activity": "Yakın zamanda senkronize edilen aktivite",
    "noSyncedActivity_sevenDays": "Son 7 günde hiçbir aktivite senkronize edilmedi",
    "recentActivityLog": {
        "convertingActivityPoints": "Aktiviteler senkronize ediliyor...",
        "activityMinuteOrTwo": "Bu bir-iki dakika sürebilir...",
        "noNewActivities": "Yeni aktivite eklenmedi... Yeni aktivitelerin senkronize olması bir saat kadar sürebilir."
    },
    "deleteCommunityCheckbox": "Bunun geri alınamayacağını anlıyorum",
    "createEvent": {
        "type": {
            "company": "Şirket etkinliği",
            "user": "Kullanıcı etkinliği",
            "title": "Etkinlik türü"
        },
        "privacy": "Gizlilik (katılımcıları göster veya gösterme)",
        "cost": "Maliyet",
        "associated": {
            "location": "İlişkili Konum",
            "department": "İlişkili Departman \/ bölüm"
        },
        "maxParticipants": "Maksimum Katılımcı Sayısı (isteğe bağlı)",
        "errorMessage": {
            "limit": "%{maxValue} değerinden büyük olamaz",
            "negative": "Negatif bir değer olamaz",
            "selectedLocations": "Lütfen bir veya daha fazla konum seçin"
        },
        "selectLocations": "Seçilen konumlar",
        "createNew": "Yeni etkinlik oluşturun"
    },
    "selected": "Seçilmiş",
    "deleteEventButton": "Bu etkinliği sil",
    "notification": {
        "priorityNotification": {
            "title": "Okunmamış önemli güncellemeleriniz var",
            "subtitle": "Şimdi okumak için dokunun",
            "subtitleWeb": "Şimdi okumak için tıklayın"
        },
        "sectionTitle": {
            "priorityUnread": "Okunmamış önemli güncellemeler",
            "all": "Tüm bildirimler"
        },
        "modalTitle": "%{count} önemli güncellemeniz var",
        "priorityModalTitle": {
            "defaultTitle": "Tüm Güncellemeleri Görüntüle"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Şunu iptal et: %{entity} %{actionType}",
            "message": "Şunu iptal etmek istediğinizden emin misiniz: %{entity} %{actionType}?"
        },
        "action": {
            "creating": "oluşturuluyor",
            "editing": "düzenleniyor"
        },
        "type": {
            "team": "ekip",
            "community": "topluluk",
            "event": "etkinlik",
            "challenge": "yarışma",
            "goal": "amaç"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Herkese açık hale getirilsin mi?",
            "private": "Gizli olarak ayarlansın mı?"
        },
        "modalSubtitle": {
            "public": "Bu %{entityType} etkinliği herkese açık olarak ayarlanırsa etkinliği herkes keşfedebilir ve etkinliğe herkes katılabilir. Bu %{entityType} etkinliğini herkese açık yapmak istediğinizden emin misiniz?",
            "private": "Bu %{entityType} etkinliği gizli olarak ayarlanırsa etkinliği kimse keşfedemez ve ona kimse katılamaz. Bu %{entityType} etkinliğini herkese açık yapmak istediğinizden emin misiniz?"
        },
        "footerButton": {
            "makePublic": "Evet, herkese açık hale getir",
            "makePrivate": "Evet, gizli olarak ayarla",
            "keepPrivate": "Gizli tut",
            "keepPublic": "Herkese açık tut"
        },
        "label": {
            "title": "Bunu herkese açık bir %{entityType} yap",
            "subtitle": "Herkes görebilir ve herkes katılabilir"
        }
    },
    "imageUploader": {
        "changeImageButton": "Resmi Değiştir"
    },
    "copyright": "Telif Hakkı © Sprout 2019",
    "samsunghealth_not_available": "Samsung Health ile bağlantı kurulamıyor. Health uygulamasında, Veri İzinleri altında, en azından adımlar için etkin izniniz olduğundan ve en az 1 adımın takip edildiğinden emin olun.",
    "rewardsHowDoIEarn": "Nasıl %{currencyName} kazanırım?",
    "unlockAchievements": "Başarıların kilidini açın",
    "unlockAchievementsDescription": "Aktiviteleri takip edin, %{pointsName} kazanın, seviyelerin kilidini açın ve daha fazla %{currencyName} kazanın. Ne yapmanız gerektiğini görmek için her başarıya dokunun.",
    "myDay": "Günüm",
    "myGoalsChallengesTasks": "Amaçlarım, yarışmalarım ve görevlerim",
    "yourGoalsChallenges": "Amaçlarınız ve yarışmalarınız",
    "mySocialStream": "Topluluk gönderileri",
    "viewAllAchievements": "Tüm başarıları görüntüle",
    "viewAllBonusChallenges": "Tüm bonus yarışmaları görüntüle",
    "newVersionOfAppAvailable": "Yeni sürüm mevcut. Lütfen bu sayfayı yeniden yükleyin",
    "noBonusChallengesToDisplay": "Şu anda hiçbir bonus yarışma mevcut değil.",
    "bonusChallenges": "Bonus yarışmalar",
    "reloadAppVersion": "Yeniden yükle",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "%{activity_name} takibini kaldırmak istediğinizden emin misiniz?",
    "activity_tracker_instruction_header": "Bir güne ait aktiviteleri takip etmek için o güne dokunun veya daha önce nelerin takip edildiğini görün.",
    "alertDashboardFunctionalityToBeAdded": "buraya, kullanıcıların sonraki yıl için statü kazanmak üzere bir takvim yılı içinde \"mil\" biriktirdikleri havayolu sadakat programlarında yapılana benzer şekilde, takip döneminin ne olduğunu açıklayan bir metin eklenecektir.",
    "noNumberEntered": "Aktivite miktarını girin",
    "feed": "Akış",
    "home": "Ana Sayfa",
    "challenges": "Yarışmalar",
    "explore": "Keşfet",
    "rewards": "Ödüller",
    "reward": "ödül",
    "balance": "%{programName} ödül bakiyem",
    "profile": "Profil",
    "loading": "Yükleniyor...",
    "me": "Ben",
    "back": "Geri",
    "next": "Sonraki",
    "skip": "Atla",
    "signup": "Kaydol",
    "signin": "Oturum aç",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Live Better'da oturum aç",
    "signup_with_medibank": "Medibank üyesi olarak kaydolun",
    "signup_with_facebook": "Facebook ile kaydolun",
    "signup_with_google": "Google ile kaydolun",
    "signup_with_email": "E-posta ile kaydolun",
    "signin_with_medibank": "Medibank'ımı kullanarak oturum aç",
    "signin_with_facebook": "Facebook ile oturum aç",
    "signin_with_google": "Google ile oturum aç",
    "signin_with_email": "E-posta ile oturum aç",
    "signup_heading": "Hesap oluşturun",
    "not_a_medibank_member": "Medibank üyesi değil misiniz?",
    "keep_me_signed_in": "Oturumumu açık tut",
    "forgotpassword": "Parolanızı mı unuttunuz?",
    "emailaddress": "E-posta adresi",
    "password": "Parola",
    "enterEmailAddress": "E-posta adresinizi girin",
    "enterYourPassword": "Parolanızı girin",
    "password_for_error": "parola",
    "reset_password": "Parolayı sıfırla",
    "passwordResetSuccess": "Parola sıfırlama",
    "passwordResetEmailSent": "Sistemimizde eşleşen bir e-posta adresi varsa parola sıfırlama talimatları size e-postayla gönderilmiştir.",
    "loginerror": "Oturum açarken bir hata oluştu:",
    "logincancelled": "Oturum açma işlemi iptal edildi",
    "part_of_corporate_program": "Kurumsal bir programa mı kaydoluyorsunuz?",
    "continue_here": "Buradan devam edin",
    "program_name": "Program adı",
    "error_provide_program_name": "Lütfen bir program adı girin.",
    "program_not_found": "Program bulunamadı",
    "registration_field_email": "E-posta adresi",
    "employeeId": "Çalışan Kimliği",
    "registration_field_firstName": "Ad",
    "registration_field_lastName": "Soyadı",
    "no_first_name": "Ad yok",
    "no_last_name": "Soyadı yok",
    "registration_field_password": "Yeni parola",
    "no_disclaimer_available": "Eyvah, bir sorun oluştu... Kuruluşunuzun hüküm ve koşullarını alamadık. Kaydolmayı lütfen daha sonra tekrar deneyin.",
    "registration_account_not_registered": "Görünüşe göre henüz e-posta adresinizi doğrulamadınız. E-postayı tekrar göndermemizi ister misiniz?",
    "resend_verification_email": "E-posta doğrulaması",
    "resend_verification_email_successful": "Doğrulama e-postanızı yeniden gönderdik.",
    "resend_verification_email_unsuccessful": "Eyvah, bir sorun oluştu... Doğrulama e-postasını yeniden gönderemedik. Lütfen tekrar deneyin.",
    "not_supported": "Bu gönderi şu anda görüntülenemiyor. Lütfen daha sonra tekrar deneyin.",
    "policyAgreeError": "Devam etmek için lütfen Hizmet Koşulları ve Gizlilik Politikası'nı kabul edin.",
    "challenge_completion_bonus": "Tamamlama bonusu",
    "me_tabs": {
        "activity": "Aktivite",
        "bookmarks": "Yer imleri"
    },
    "health_tab": {
        "my_health_score": "İyilik hali puanınız",
        "overall_health_score_description": "İyilik hali puanınız:",
        "health_score_explanation": "İyilik hali puanınız, sağlığınız ve ne kadar aktif olduğunuzla ilgili yanıtlarınızdan hesaplanır. \n \nPuanınız, aktivite seviyelerinize göre her ay güncellenir. İyilik hali puanınızı iyileştirmek için kişisel amaçlar belirleyebilir ve bunları tamamlayabilirsiniz.",
        "health_score_calculation_failed_onboarding": "Bir şeyler ters gitti ve iyilik hali puanınızı alamadık. Şimdilik devam edebilirsiniz. Sorun çözülür çözülmez puanınızı güncelleyeceğiz."
    },
    "track_activity": "Aktiviteyi takip et",
    "track_an_activity": "Bir aktiviteyi takip et",
    "track": "Takip et",
    "unable_to_track": "Takip edilemiyor",
    "enter_before_track": "Takip edilecek aktivite miktarını girin",
    "what_to_share": "Ne tür bir güncelleme paylaşmak istersiniz?",
    "remove": "Kaldır",
    "activity_tracking_description": "Kaç %{units} takip etmek istiyorsunuz?",
    "excessive_submission": "Vay canına! %{activity_name} için 2.000'den fazla %{customPoints} takip etmek üzeresiniz. Göndermeden önce bunun doğru olduğundan emin olmak isteyebilirsiniz.",
    "on": "üzerinde",
    "in": "içinde",
    "from": "kaynaklı",
    "at": "konumunda",
    "no_activities": "Aramanızla eşleşen aktivite bulunamadı.",
    "activity_tracking_desc": "Devam etmek için bir numara eklemeniz gerekiyor. İptal etmek için sol köşedeki X'e dokunun.",
    "activity_tracking_desc2": "Düzenlemek için aktivitenin herhangi bir yerine dokunun, amaca hızlı bir şekilde ulaşmak için + öğesine dokunun",
    "vital_stats_title": "Hakkınızda",
    "invalid_numeric_response": "Geçersiz",
    "invalid_numeric_response_range": "Bu sayı %{minimum} ile %{maximum} arasında olmalıdır",
    "search_placeholder": "Kütüphanede ara...",
    "search_activities": "Aktiviteleri ara",
    "searching": "Aranıyor...",
    "searchEmpty": "Eşleşme bulunamadı",
    "vital_stats_description": "Bize biraz kendinizden bahseder misiniz?",
    "health_survey_questions": "İyilik hali anketi soruları",
    "health_survey_title": "İ̇yilik hali anketini tamamlayın",
    "health_survey_results": "İyilik hali anketi sonuçları",
    "health_survey_card_desc": "Ankete katılarak iyilik halinizin anlık durumunu görün ve kişiselleştirilmiş amaçlar belirleyin.",
    "apps_devices_title": "Uygulamaları ve cihazları bağlama",
    "apps_devices_card_desc": "Uygulamalarınızı ve cihazlarınızı senkronize ederek %{customPoints} kazanmayı kolaylaştırın.",
    "interests_title": "İ̇lgi alanları",
    "interests_card_desc": "İlgi alanlarınızdan bahsedin. Bu, ilginizi çekebilecek amaçlar ve topluluklar önermemize yardımcı olacaktır.",
    "interests_screen_desc": "Ne ile ilgileniyorsunuz?",
    "health_obj_title": "İyilik hali hedefleri",
    "health_obj_card_desc": "Bazı amaçlar belirleme zamanının geldiğini düşünüyoruz. Hedeflerinizi öğrendikten sonra sizin için daha iyi önerilerde bulunabileceğiz. Endişelenmeyin, fikrinizi değiştirirseniz daha sonra profilinizde kolayca değişiklik yapabilirsiniz. ",
    "health_obj_screen_desc": "Hangi alanlar üzerinde çalışmak istersiniz?",
    "my_heatlh_obj": "İyilik hali hedeflerim",
    "health_topic_title": "İyilik hali konuları",
    "health_topic_card_desc": "İylik hali konularınızı belirleyerek deneyiminizi kişiselleştirin.",
    "health_topic_screen_desc": "Ne hakkında bilgi edinmek istiyorsunuz?",
    "multi_select_check_error": "Devam etmek için lütfen en az 1 seçenek işaretleyin",
    "my_health_topics": "İyilik hali konularım",
    "build_your_profile": "Profilinizi oluşturun",
    "personalize_title": "Kişiselleştirin",
    "personalize_desc": "Birkaç kısa soruyu yanıtlayarak deneyiminizi kişiselleştirin.",
    "set_goals_title": "Önerilen amaçlara bakın",
    "set_goals_desc": "Sağlığınızı iyileştirme yolculuğunuza başlamak için kişiselleştirilmiş amaçlar belirleyin.",
    "set_this_goal": "Bu amacı belirle",
    "goal_set": "Amaç belirlendi",
    "required": "Gerekli",
    "apps_devices_description": "Otomatik olarak daha fazla %{customPoints} kazanmak için bir fitness platformuna bağlanın.",
    "connected": "Bağlı",
    "num_connected": "(%{numDevices} bağlı)",
    "available": "Mevcut",
    "inProgress": "Devam ediyor...",
    "time_a_m": "am",
    "time_p_m": "pm",
    "last_synced": "Son senkronizasyon",
    "last_synced_lc": "son senkronizasyon",
    "no_connected_devices": "Bağlı cihaz yok",
    "apps_devices_confirm_disconnect": "Bağlantıyı kesmek istediğinizden emin misiniz?",
    "button_delete": "Sil",
    "button_disconnect": "Bağlantıyı kes",
    "button_cancel": "İ̇ptal et",
    "button_dismiss": "İptal et",
    "ok": "Tamam",
    "waist_helper_text": "Bel ölçünüz kaburgaların altından, genellikle göbek hizasından ve ayaktayken alınmalıdır. Emin değilseniz kot pantolon bedeninizi kullanın.",
    "apps_devices_manage": "Uygulamalarımı ve cihazlarımı yönet",
    "my_apps_devices": "Uygulamalarım ve cihazlarım",
    "completeRegistration": "Kaydı tamamla",
    "havingTrouble": "Sorun mu yaşıyorsunuz?",
    "contactUs": "Yardım için support@sproutatwork.com adresine başvurun",
    "done": "Bitti",
    "brand": "Sprout",
    "cannotTrackTitle": "Aktivite takip edilemiyor",
    "cannotTrackPrior": "Acele etmeyin. Aktiviteler ancak başlangıç tarihinden sonra takip edilebilir.",
    "cannotTrackFuture": "O kadar hızlı değil. Aktiviteler sadece içinde bulunulan güne kadar takip edilebilir.",
    "cannotTrack": "Aktiviteler başlangıç tarihinden önce veya gelecekteki bir gün için takip edilemez.",
    "disclaimer": "Sorumluluk reddi",
    "acceptTerms": "Hüküm ve koşulları kabul ediyorum",
    "verificationEmailTitle": "E-posta adresinizi doğrulayın",
    "email_not_yet_verified": "Görünüşe göre e-posta adresinizi henüz doğrulamadınız.",
    "email_successfully_verified_title": "Hoş geldiniz",
    "email_successfully_verified": "E-posta adresinizi başarıyla doğruladınız",
    "pleaseVerifyEmailMessage1": "Devam etmek için e-posta adresinizi doğrulamanız gerekiyor.",
    "pleaseVerifyEmailMessage2": "Lütfen şu adrese gönderilen talimatları izleyin:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "E-postayı yeniden gönder",
    "restart": "Girişe geri dön",
    "firstName": "Ad",
    "firstNamePlaceholder": "Adınız",
    "lastName": "Soyadı",
    "lastNamePlaceholder": "Soyadınız",
    "email": "E-posta adresi",
    "emailPlaceholder": "E-posta adresiniz",
    "employeId": "Çalışan Kimliği",
    "employeIdPlaceholder": "Şirket çalışanı kimliği",
    "passwordPlaceholder": "Yeni parola",
    "datePickerTitle": "Doğum tarihinizi seçin",
    "datePickerConfirm": "Onayla",
    "datePickerCancel": "İ̇ptal et",
    "termsOfUsePrivacyPreLinks": "Şunları kabul ediyorum:",
    "sendMePromoCommunications": "Bana promosyon mesajları gönder",
    "sendMePromoCommunicationsFromPartners": "Bana ortaklardan gelen promosyon mesajlarını gönder",
    "termsOfService": "Hizmet Koşulları",
    "legal": "Yasal",
    "privacyPolicy": "Gizlilik Politikası",
    "and": "ve",
    "programDomainLabel": "Program adı",
    "programDomainPlaceholder": "Program adı",
    "findProgramName": "Program adımı bul",
    "findProgramNameButton": "Program adını bul",
    "findProgramNameTitle": "Program adımı bul",
    "findProgramNameDescription": "Şirket e-posta adresi",
    "findProgramNamePlaceholder": "E-posta adresi",
    "findProgramSuccessMessage": "Program adı aramasının sonuçları tarafınıza e-postayla iletilmiştir.",
    "findProgramSuccessTitle": "Program adı",
    "findProgramErrorTitle": "Program adı",
    "findProgramErrorMessage": "Eyvah, bir sorun oluştu... Program adınızı almaya çalışırken bir hatayla karşılaştık. Lütfen tekrar deneyin.",
    "countryLabel": "Ülke seçin",
    "countryName": "Ülke",
    "regionLabel": "Bölge seçin",
    "regionName": "Bölge",
    "cityLabel": "Şehir seçin",
    "cityName": "Şehir",
    "locationWorkLabel": "Konum seçin",
    "locationWorkName": "Konum",
    "locationLabel": "Konum seçin",
    "locationName": "Konum",
    "departmentLabel": "Departman \/ bölüm seçin",
    "departmentName": "Departman \/ bölüm",
    "no_department": "Departman \/ bölüm yok",
    "enterPIN": "Lütfen şirket PIN'inizi girin",
    "verifyEmailTitle": "E-posta doğrulaması",
    "verifyEmailMsg": "Görünüşe göre e-posta adresinizi henüz doğrulamadınız",
    "resendEmailTitle": "E-posta doğrulaması",
    "resendEmailMsg": "%{userEmail} adresine yeniden gönderildi",
    "select_date": "Bir tarih seçin",
    "changePasswordTitle": "Parolayı değiştir",
    "currentPassword": "Geçerli parola",
    "newPassword": "Yeni parola",
    "confirmNewPassword": "Yeni parolayı doğrulayın",
    "passwordChangeError": {
        "currentPasswordMissing": "Geçerli parolanızı girin",
        "newPasswordMissing": "Yeni parolanızı girin",
        "confirmPasswordMissing": "Yeni parolanızı doğrulayın",
        "passwordsMatch": "Parolalar eşleşmiyor",
        "passwordIncorrect": "Yanlış parola. Lütfen tekrar deneyin."
    },
    "settings": "Ayarlar",
    "signOut": "Çıkış yap",
    "updateApp": "Uygulamayı güncelle",
    "updateAppRight": "Güncel: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Yardım alın",
    "feedback": "Geri bildirim",
    "feedback_success_title": "Geri bildirim gönderildi",
    "feedback_success_msg": "Geri bildiriminizi gönderdiğiniz için teşekkür ederiz, gerçekten minnettarız.",
    "feedback_failure_title": "Hata",
    "feedback_failure_msg": "Tüh... Geri bildiriminiz gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
    "submit": "Gönder",
    "feedback_char_limit": "Karakter sınırını aştınız.",
    "feedback_char_limit_toast_title": "Mesaj çok uzun",
    "feedback_char_limit_toast_msg": "Mesajınız 2000 karakterlik maksimum sınırı aşıyor.",
    "feedback_char_length_msg_1": "Yazdığınız:",
    "feedback_char_length_msg_2": "\/2000 karakter.",
    "feedback_empty_toast_title": "Mesaj boş",
    "feedback_empty_toast_msg": "Görünüşe göre henüz hiçbir şey yazmamışsınız. Göndermeden önce bir mesaj yazın.",
    "feedback_email_message": "Mesaj:",
    "feedback_email_user_id": ", Kullanıcı kimliği:",
    "feedback_email_device": ", Cihaz:",
    "feedback_email_os_version": ", İşletim Sistemi Sürümü:",
    "feedback_email_app_version": ", Uygulama Sürümü:",
    "savingUserToast": {
        "success": {
            "title": "Değişiklikleri kaydet",
            "message": "Profil değişiklikleri kaydedildi"
        },
        "danger": {
            "title": "Hatayla karşılaşıldı",
            "message": "Eyvah... Değişikliklerinizi kaydetmeye çalışırken bir hatayla karşılaştık. Lütfen tekrar deneyin."
        }
    },
    "edit_profile_user_error_msg": "Değişikliklerinizi kaydetmeden önce lütfen hataları inceleyin",
    "edit_profile_location_error": "Konumunuzu belirtmeniz gerekiyor",
    "edit_profile_department_error": "Departmanınızı \/ bölümünüzü belirtmeniz gerekir",
    "edit_profile_unspecified_value": "Bir değer belirtmeniz gerekir",
    "edit_profile_value_too_low": "Değer şundan fazla olmalıdır:",
    "edit_profile_value_too_high": "Değer şundan az olmalıdır:",
    "choose_gender": "Cinsiyeti seçin",
    "activity_tracked_successfuly": "Aktiviteniz takip ediliyor",
    "multi_activity_tracked_successfully": "Aktiviteleriniz takip ediliyor",
    "no_activities_tracked": "Takip edilen aktivite yok",
    "track_activity_to_submit": "Bir aktiviteyi takip etmek için takvimde bir tarih seçin",
    "last_day": "Son",
    "days_remaining": "gün kaldı",
    "day_remaining": "gün kaldı",
    "days_remaining_this_week": "gün kaldı (bu hafta)",
    "day_remaining_this_week": "gün kaldı (bu hafta)",
    "days_remaining_this_month": "gün kaldı (bu ay)",
    "day_remaining_this_month": "gün kaldı (bu ay)",
    "earned_today": "Bugün kazanılan",
    "earned_this_week": "Bu hafta kazanılan",
    "earned_this_month": "Bu ay kazanılan",
    "earned_in_total": "Toplamda kazanılan",
    "goal_completed": "Amaç tamamlandı,",
    "see_results": "sonuçları gör",
    "pts": "",
    "of": "\/",
    "daily_goal": "Günlük amaç",
    "weekly_goal": "Haftalık amaç",
    "monthly_goal": "Aylık amaç",
    "total_goal": "Toplam amaç",
    "weeks": "hafta",
    "today": "Bugün",
    "this_week": "Bu hafta",
    "this_month": "Bu ay",
    "overall": "Genel",
    "level": "Seviye",
    "days_remaining_in_period": "%{remainingDays} gün kaldı",
    "days_left_in_period": "Takip edilecek %{remainingDays} gün kaldı",
    "pointsToLevel": "%{levelName} doğrultusunda ilerleme",
    "levelCompleted": "%{levelName} tamamlandı",
    "keepTrackingUntil": "Şu zaman kadar takip etmeye devam et",
    "activityLevelTitle": "Aktivite seviyem",
    "activityLevelDescription": "Tipik bir haftada, orta düzeyde aktif olarak, yani kalp atış hızınızı artıracak ve ter atacak kadar yoğun bir şekilde hareket ederek ne kadar zaman geçiriyorsunuz? ",
    "activityLevelUnder60": "60 dakikanın altında",
    "activityLevelUnder150": "60 ila 150 dakika",
    "activityLevelOver150": "150 dakikadan fazla",
    "gender_male": "Erkek",
    "gender_female": "Kadın",
    "gender_rather_not_say": "Söylememeyi tercih ederim",
    "date_of_birth": "Doğum tarihi",
    "height": "Boy",
    "Height": "Boy",
    "weight": "Kilo",
    "waistCircumference": "Bel çevresi",
    "bloodPressureHg": "Sistolik kan basıncı",
    "bloodPressureMm": "Diyastolik kan basıncı",
    "bloodCholesterol": "Toplam kan kolesterolü",
    "ldl": "Düşük yoğunluklu lipoprotein (LDL)",
    "hdl": "Yüksek yoğunluklu lipoprotein (HDL)",
    "restingHeartRate": "Dinlenme kalp atış hızı",
    "percentageBodyFat": "Vücut yağ yüzdesi",
    "hipCircumference": "Kalça çevresi",
    "bloodGlucose": "Kan Şekeri",
    "triglycerides": "Trigliseritler",
    "error_401_signed_out_message": "Oturumunuz sona erdi. Lütfen tekrar oturum açın.",
    "first_name": "Ad",
    "last_name": "Soyadı",
    "preferred_name": "Tercih edilen isim",
    "notifications": "Bildirimler",
    "notificationsMarkAllReadButton": "Tüm bildirimleri okundu olarak işaretle",
    "notificationsSettingsButton": "Ayarlar",
    "notificationsSettingsTitle": "Bildirimler ve e-postalar",
    "notificationEmptyMessage": "Bildirimleriniz güncel",
    "priorityModalTitle": "Öncelikli bildirimlerim",
    "remindMeLater": "Daha sonra hatırlat",
    "priorityAdminTitle": "Yöneticinizden gelen bildirim",
    "markAsRead": "Okundu olarak işaretle",
    "expand": "Genişletmek için dokunun",
    "collapse": "Daraltmak için dokunun",
    "takePhoto": "Yeni bir fotoğraf çekin",
    "choosePhoto": "Bir fotoğraf seçin",
    "deletePhoto": "Fotoğrafı sil",
    "profileImageChangeErrorTitle": "Hatayla karşılaşıldı",
    "profileImageChangeErrorMessage": "Eyvah…... Fotoğrafınız düzenlenirken bir sorun oluştu. Lütfen tekrar deneyin.",
    "editProfile": "Profili düzenle",
    "postButton": "Paylaş",
    "shareYourDayName": "Neler yapıyorsunuz?",
    "greeting": "Merhaba, %{firstNameDisplay}!",
    "shareAnUpdate": "Neler yapıyorsunuz?",
    "shareYourDaySubtitle": "Neler yapıyorsunuz?",
    "shareAPost": "Bir gönderi paylaşın",
    "postVisibleTo": "Şu kişilere görünür:",
    "link": "Bağlantı",
    "photo": "Fotoğraf",
    "insertLink": "Gönderinize bir bağlantı ekleyin",
    "save": "Kaydet",
    "sampleLink": "http:\/\/ornek.com",
    "shareErrorText": "Göndermeden önce gönderinize içerik eklemeniz gerekmektedir.",
    "generalErrorTitle": "Gönderi boş",
    "generalSuccessTitle": "Başarılı",
    "simplePlaceholder": "Neler yapıyorsunuz?",
    "likesCountLabel": "Beğeni",
    "likesReceivedLabel": "Alınan beğeniler",
    "commentsCountLabel": "Yorumlar",
    "commentsCountLabelSingular": "Yorum",
    "likeButton": "Beğeni",
    "commentButton": "Yorum",
    "seePreviousComments": "Önceki yorumlara bakın",
    "addCommentPlaceholder": "Yorum ekle",
    "postCommentButton": "Paylaş",
    "seeMoreLongComment": "Daha fazlasını gör",
    "activityPoints": "",
    "activityLog": "Aktivite günlüğü",
    "discardPost": "İptal et",
    "discardPostMessage": "Gönderinizi iptal etmek istediğinizden emin misiniz?",
    "stream_filter_title": "Akış",
    "stream_filter_screen_desc": "Akışta görüntülemek istediğiniz gönderileri seçin",
    "stream_filter_selection": "Gösterilen:",
    "moderate": "Uygunsuz olarak işaretle",
    "moderateDescription": "Bu öğeyi uygunsuz olarak işaretlemek, öğenin kaldırılmasına ve bir yöneticiye bildirilmesine neden olacaktır.",
    "editPost": "Gönderiyi düzenle",
    "deletePost": "Gönderiyi sil",
    "deleteComment": "Yorumu sil",
    "editComment": "Yorumu düzenle",
    "visibleOnlyToMe": "Sadece bana görünür",
    "joinEvent": "Etkinlik için RSVP",
    "joinEventDetail": "Etkinliğe katıl",
    "joinedEvent": "Ben gidiyorum",
    "joiningEventToast": {
        "success": {
            "title": "",
            "messageName": "Etkinliğe katıldınız",
            "message": "Bu etkinliğe başarıyla katıldınız"
        }
    },
    "joinChallenge": "Yarışmaya katıl",
    "viewChallenge": "Yarışmayı görüntüle",
    "joinedChallenge": "Yarışmaya katıldı",
    "joinCommunity": "Topluluğa katıl",
    "joinedCommunity": "Topluluğa katıldı",
    "joinProgress": "Katılma işlemi devam ediyor",
    "joinSuccess": "Katılma işlemi tamamlandı",
    "invitePeopleToCommunity": "Topluluğa kişi davet edin",
    "numberOfMembers": "%{num} üye",
    "joinToView": "Diğer üyeleri görüntülemek ve onlara mesaj göndermek için bu topluluğa katılın",
    "numberOfAttendees": "%{num} katılımcı",
    "numberOfParticipants": "%{num} katılımcı",
    "numberOfMembersWithUser": "Siz ve %{num} diğer üye",
    "numberOfAttendeesWithUser": "Siz ve %{num} diğer katılımcı",
    "numberOfParticipantsWithUser": "Siz ve %{num} diğer katılımcı",
    "communityMembers": "%{numberOfMembers} üye",
    "communityEvents": "Yaklaşan %{numberOfEvents} etkinlik",
    "myEvents": "Etkinliklerim",
    "seeAll": "Tümünü gör",
    "noUpcomingEvents": "Yaklaşan etkinlik yok. Birine katılalım!",
    "myCommunities": "Topluluklarım",
    "invitedCommunities": "Davetli",
    "invitationSendingMessage": "Davetler gönderiliyor...",
    "invitationReceivedMessage": "sizi şuna katılmaya davet etti:",
    "invitationMessage": "Sizi topluluğumuzda görmekten mutluluk duyarız.",
    "recommendedCommunities": "Sizin için önerilen",
    "leaveCommunity": "Bu topluluktan ayrıl",
    "leaveTeam": "Bu yarışmada",
    "leaveTeamLastMember": "ekibinden ayrılmak istediğinizden emin misiniz? Ekibin son üyesi olarak bu yarışmadan ayrılmanız durumunda ekip silinir.",
    "leaveTeamChallenge": "ekibinden ayrılmak istediğinizden emin misiniz?",
    "Oops": "Eyvah, bir şeyler ters gitti",
    "editCommunity": "Topluluğu düzenle",
    "deleteCommunity": "Bu topluluğu sil",
    "leaveCommunityDescription": "Bu topluluktan ayrılmak istediğinizden emin misiniz?",
    "inviteToCommunity": "Topluluğa davet et",
    "inviteByMembers": "İsimle davet et",
    "inviteByEmail": "E-posta ile davet et",
    "select_person": "Lütfen davet etmek için en az bir kişi seçin",
    "no_users_found": "Hmm... O isimde birini bulamadık.",
    "promptJoinCommunities": "Görünüşe göre hiçbir topluluğa katılmadınız. Başkalarıyla etkileşim kurmak ve yolculuğunuzu paylaşmak için topluluklara katılın.",
    "exploreCommunities": "Toplulukları keşfedin",
    "sendInviteByMembers": "%{num} kişi davet edin",
    "sendInviteByEmail": "E-posta daveti gönderin",
    "createNewCommunity": "Yeni bir topluluk oluşturun",
    "createCommunity": "Topluluk oluştur",
    "uploadCover": "Bir fotoğraf ekleyin",
    "cover": "Kapak",
    "nameOfCommunity": "Topluluk adı",
    "whatCommunityAbout": "Bu topluluk ne hakkında?",
    "companyMembersOnly": "Sadece şirket üyeleri",
    "viewAllButton": "Tümünü görüntüle",
    "communities": "Topluluklar",
    "contentLibrary": "Kütüphane",
    "events": "Etkinlikler",
    "past_events": "Geçmiş etkinlikler",
    "invitationCommunity": "topluluk",
    "searchPeople": "Kişi arama",
    "enterEmail": "E-posta adresi girin",
    "personalMessageToNewInvitees": "Yeni davetlilere kişisel mesaj",
    "dangerToastTitle": "Hata",
    "dangerToastMessage": "Hmm... Bir şeyler ters gitti. Lütfen tekrar deneyin.",
    "successToastTitle": "Başarılı!",
    "successToastMessage": "Eylem tamamlandı",
    "joiningToast": {
        "success": {
            "message": "Katıldınız"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Yorum silindi"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Yorum uygunsuz olarak işaretlendi"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Yorum güncellendi"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Yorum güncellendi"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Profil fotoğrafı güncellendi"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Fotoğraf silindi"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Yayın akışına gönder",
            "message": "Gönderiniz oluşturuldu"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Gönderiyi düzenle",
            "message": "Gönderiniz düzenlendi"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Gönderiyi sil",
            "message": "Gönderiniz silindi"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Uygunsuz olarak işaretle",
            "message": "Gönderi uygunsuz olarak işaretlendi"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Okundu olarak işaretle",
            "message": "Tüm bildirimler okundu olarak işaretlendi"
        },
        "info": {
            "title": "Okundu olarak işaretle",
            "message": "Tüm bildirimler zaten okundu olarak işaretlendi."
        },
        "danger": {
            "title": "Okundu olarak işaretle"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Bildirim okundu olarak işaretlenemiyor"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Parola güncellendi",
            "message": "Yeni parolanızla giriş yapın"
        },
        "danger": {
            "title": "Parolayı güncelle",
            "message": "Eyvah… Parolanızı güncellemeye çalışırken bir sorun oluştu. Lütfen tekrar deneyin."
        }
    },
    "joining": {
        "success": {
            "message": "Şuraya katıldınız: %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Davetler",
            "message": "Davetler gönderildi"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Topluluk oluştur",
            "message": "Yeni topluluğunuz oluşturuldu"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Amacınız yeniden başlatıldı"
        },
        "danger": {
            "message": "Amaç yeniden başlatılamıyor"
        }
    },
    "quit": "Çıkış yap",
    "wellbeing_survey_completed": "İyilik hali anketi tamamlandı",
    "wellbeing_survey_completed_message": "Anketi tamamladığınız için teşekkür ederiz. Anketin, iyilik haliniz hakkında biraz fikir edinmenize yardımcı olmasını umuyoruz.",
    "update_wellbeing_score": "Anket cevaplarımı güncelle",
    "get_wellbeing_score": "İyilik hali puanınızı alın",
    "stats": "İstatistikler",
    "my_wellbeing_score": "İyilik hali puanım",
    "see_details": "Ayrıntılara bakın",
    "how_score_calculated": "Puanım nasıl hesaplanır?",
    "contentTitle": "Kütüphane",
    "promoted": "Öne çıkan",
    "recommended": "Önerilen",
    "recommendedForMe": "Benim için önerilen",
    "recent": "Son eklenenler",
    "view": "Görünüm",
    "added": "Eklendi",
    "more": "daha fazla",
    "openLibrary": "Beni kütüphaneye götür",
    "readToEarn": "Kazanmak için okuyun",
    "readArticle": "Bağlantıyı aç",
    "see_more": "Daha fazlasını gör (%{num})",
    "see_more_activities": "%{num} adet daha",
    "my_achievements": "Başarılarım",
    "achievements": "Başarılar",
    "achievement_earned_date": "Kazanma: %{date}",
    "achievement_start_date": "Başlangıç: %{date}",
    "achievement_end_date": "Sona erme: %{date}",
    "achievement_earned": "Kazanılan",
    "achievement_start": "Başlama:",
    "achievement_end": "Sona erme:",
    "achievement_earned_times": "%{num} kez",
    "achievement_earned_time": "%{num} kez",
    "in_progress": "Devam ediyor",
    "date_earned": "Kazanıldığı tarih",
    "earned": "Kazanılan",
    "past_dates_earned_heading": "Kazanıldığı geçmiş tarihler",
    "all": "Tümü",
    "eat": "Beslenmek",
    "move": "Hareket etmek",
    "feel": "Hissetmek",
    "profile_completion": "Profil tamamlama: %%{percentage}",
    "complete_my_profile": "Profilinizi tamamlayın",
    "do_following_tasks": "Profilinizi tamamlamak için aşağıdaki %{num} görevini yapın.",
    "improve_my_score": "Puanınızı artırın",
    "see_which_goals": "Beslenme, hareket etme ve kendinizi daha iyi hissetme konusunda belirlediğiniz amaçlara göz atın.",
    "havent_set_goal": "Henüz bir amaç belirlemediniz.",
    "set_a_goal": "Bir amaç belirle",
    "set_another_goal": "Başka bir amaç belirle",
    "set_another_goal_here": "Burada başka bir amaç belirleyin.",
    "my_recently_tracked_activities": "Son aktivitelerim",
    "a_few_seconds_ago": "birkaç saniye önce",
    "a_day_ago": "bir gün önce",
    "yesterday": "Dün",
    "earn": "Kazanın",
    "delete_activity_confirmation": "Bu aktiviteyi kaldırmak istediğinizden emin misiniz?",
    "delete_activity_title": "%{measurement} \/ %{activity_name} kaldırılsın mı?",
    "reached_daily_goal": "Bugün amacınıza ulaştınız. İyi iş çıkardınız!",
    "multiple_activity_non_daily_instruction": "Takip etmeye başlamak ve %{customPoints} kazanmak için bir aktivite satırına dokunun.",
    "multiple_activity_daily_instruction": "Amacınıza ulaşmak için gereken aktivite miktarını takip etmek için artı işaretine dokunun. Söz konusu aktivitenin herhangi bir miktarını takip etmek için aktivite satırında başka bir yere dokunun.",
    "only_automatic_activities": "Bu amaca katkıda bulunan aktiviteler yalnızca otomatik olarak izlenebilir",
    "only_automatic_activity": "Bu amaca katkıda bulunan aktivite yalnızca otomatik olarak izlenebilir",
    "earn_pts_and_reach_goal": "%{pts} puan kazanın ve %{qty} takip ederek amacınıza ulaşın",
    "earn_pts_for_every": "%{pts} puan kazanın (takip ettiğiniz her",
    "you_track": "için).",
    "you_have_tracked": "%{qty} takip ettiniz",
    "so_far": "şu ana kadar!",
    "start_goal": "Bu amacı belirle",
    "about_this_goal": "Bu amaç hakkında",
    "start_date": "Başlangıç tarihi",
    "end_date": "Bitiş tarihi",
    "activities": "Aktiviteler",
    "goal": "Amaç",
    "instructions": "Talimatlar",
    "daily": "Günlük",
    "weekly": "Haftalık",
    "monthly": "Aylık",
    "total": "Toplam",
    "week": "Hafta",
    "day": "Gün",
    "days": "Gün",
    "month": "Ay",
    "months": "Ay",
    "progress": "İlerleme",
    "about": "Hakkında",
    "days_remaining_to_track": "Kaçırdığınız herhangi bir aktiviteyi takip etmek için %{num} gününüz var",
    "number_days": "%{num} gün",
    "one_day": "1 gün",
    "points_earned_this_week": "Bu hafta kazanılan puanlar",
    "points_earned_year": "Yıl başından bu yana kazanılan puanlar",
    "completed": "Tamamlandı",
    "what_you_need_to_do": "Yapmanız gerekenler",
    "see_all_num": "%{num} adedin tümünü gör",
    "my_week_progress": "Haftalık ilerlemeniz",
    "my_day_progress": "Günlük ilerlemeniz",
    "my_month_progress": "Aylık ilerlemeniz",
    "my_total_progress": "Toplam ilerlemeniz",
    "my_overall_progress": "Genel ilerleme",
    "you_earned": "Kazandınız",
    "of_this_week": "\/ %{num} (bu hafta)",
    "of_this_day": "\/ %{num} (bugün)",
    "of_this_month": "\/ %{num} (bu ay)",
    "of_this_total": "\/ %{num} toplamda",
    "of_this_overall": "\/ %{num} genel",
    "remaining_this_week": "bu hafta kalan",
    "remaining_this_month": "bu ay kalan",
    "remaining_this_total": "kalan",
    "remaining_this_overall": "genel olarak kalan",
    "view_history": "Geçmişi görüntüle",
    "this_goal_is": "Bu amaç",
    "will_run_for": "Şunun için koşacak:",
    "button_unset_goal": "Amacı iptal et",
    "button_leave_challenge": "Yarışmadan ayrıl",
    "leaveChallenge": {
        "menu": "Şuradan ayrıl: %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Şunu sil: %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "",
            "message": "Bu kişisel amacı iptal ettiniz."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Yarışmadan ayrıldınız."
        }
    },
    "activities_tracked": "Takip edilen aktiviteler",
    "recently_tracked_activities": "Son zamanlarda takip edilen aktiviteler",
    "add": "Ekle",
    "change_before_track": "Görünüşe göre hiçbir değişiklik yapmamışsınız. Bu gün için aktivite miktarını düzenleyin veya değişiklik yapmadan çıkın.",
    "havent_tracked_today": "Görünüşe göre bu gün için henüz hiçbir aktiviteyi takip etmediniz. Bir aktivite arayarak başlayın.",
    "cancel_tracking_quantity": "%{quantity} %{activity_name} takibini iptal et",
    "points": "",
    "discard_activity_edits_confirmation": "Çıkılırsa aktivite geçmişinizdeki düzenlemeler iptal edilir. Emin misiniz?",
    "discard_activity_edits_confirmation_date": "Çıkılırsa %{date} için aktivite geçmişinizdeki düzenlemeler iptal edilir. Emin misiniz?",
    "yes_discard_edits": "Evet, çık ve düzenlemeleri iptal et",
    "createGoal": {
        "navigatorTitle": "Kişisel amaç oluşturma",
        "navigatorSubtitle": "Adım %{step} \/ 4"
    },
    "allCommunities": "Her şey",
    "deleteCommunityDescription": "Bu topluluğu silmek istediğinizden emin misiniz?",
    "remaining": "kalan",
    "recommended_goal": "Önerilen amaç",
    "pinError": "PIN %{pin} geçerli değil. Lütfen tekrar deneyin.",
    "previousPersonalGoals": "Tamamlanmış kişisel amaçlarım",
    "previousGoalsTitle": "Önceki amaçlarım",
    "endedOn": "sona erme zamanı:",
    "achievedOfGoal": "Amacın şu kadarını başardınız: %%{num}",
    "previousGoalsEmptyMessage": "Önceki amacınız yok",
    "emptyListDefaultMessage": "Burada hiçbir öğeniz yok",
    "myCommunitiesEmpty": "Görünüşe göre hiçbir topluluğa katılmadınız. Başkalarıyla etkileşim kurmak ve yolculuğunuzu paylaşmak için topluluklara katılın.",
    "discoverMoreCommunities": "Daha fazla topluluk keşfedin",
    "howLong": "Süre",
    "frequency": "Sıklık",
    "discard": "İptal et",
    "description": "Açıklama",
    "optional": "isteğe bağlı",
    "instruction": "Talimat",
    "name": "Ad",
    "create": "Oluştur",
    "categories": "Kategoriler",
    "uploadPhoto": "Bir fotoğraf ekleyin",
    "delete_goal": "Şunu sil: %{name}",
    "delete_goal_confirmation": "Bu amacı silmek istediğinizden emin misiniz?",
    "leave_goal_confirmation": "Bu yarışmadan ayrılmak istediğinizden emin misiniz?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Amacınız oluşturuldu."
        }
    },
    "defaultSelectMessage": "Lütfen bir seçenek seçin",
    "search": "Arama",
    "inTotal": "toplamda",
    "State": "Durum",
    "Business unit": "İş birimi",
    "Work location": "Çalışma yeri",
    "whenStart": "Ne zaman başlamak istersiniz?",
    "every": "sıklık:",
    "acceptChallenge": "Yarışmayı kabul et",
    "activity_history_challenge": "Yarışma için aktivite geçmişi",
    "havent_tracked_challenge": "Bu yarışma için hiçbir aktivite izlemediniz",
    "earned_lowercase": "kazanılan",
    "noone_tracked_yet": "Henüz kimse hiçbir şeyi takip etmedi. Bu müsabakada lider olmak için takip etmeye başlayın.",
    "you": "Siz",
    "your_team": "Ekibim",
    "congrats_first_place": "Birinci oldunuz. Tebrikler! İyi iş çıkardınız, böyle devam.",
    "leader": "Lider",
    "average": "Ortalama",
    "show_leader": "Lideri göster",
    "show_me": "Beni göster",
    "show_my_team": "Ekibimi göster",
    "leaderboard": "Puan tablosu",
    "my_team": "Ekibim",
    "remaining_to_track": "takip etmek için kalan süre",
    "avg": "ort.",
    "invite": "Davet et",
    "team_members": "Ekip üyeleri",
    "daysLeft": "Kalan gün sayısı",
    "regionNameLiveBetter": "Durum",
    "locationNameLiveBetter": "Çalışma yeri",
    "departmentNameLiveBetter": "İş birimi",
    "regionLabelLiveBetter": "Eyalet seçin",
    "locationLabelLiveBetter": "Çalışma yeri seçin",
    "departmentLabelLiveBetter": "İş birimi seçin",
    "companyLocation": "Çalışma yeri",
    "no_location": "Konum yok",
    "connect": "Bağlan",
    "syncing": "Senkronize ediliyor",
    "sync": "Senkronizasyon",
    "havent_tracked_in_a_while": "Son zamanlarda takip edilen aktivite yok",
    "contact": "İletişim",
    "manage": "Yönet",
    "creator": "Oluşturucu",
    "allow_notifications": "Bildirimleri yönet",
    "enable_notifications": "Bildirimleri aç",
    "appload": "{app_name} güncellenirken biraz bekleyin...",
    "sendResetEmail": "Sıfırlama e-postası gönder",
    "min": "Minimum",
    "max": "Maksimum",
    "error_joining_team": "Ekibe katılamıyor",
    "cannot_add_to_team": "Eyvah... Sizi bu takıma eklemeye çalışırken bir sorun oluştu. Ekip maksimum üye sayısına ulaşmış olabilir veya artık mevcut olmayabilir. Başka bir hata oluşması durumunda lütfen tekrar deneyin.",
    "members_needed": "%{num} üye gerekli",
    "member_needed": "%{num} üye gerekli",
    "spots_left": "%{num} boş yer kaldı",
    "join": "Katıl",
    "no_teams_create": "Şu anda katılabileceğiniz bir ekip yok. Neden bir tane oluşturmuyorsunuz?",
    "number_teams": "%{num} ekip",
    "youLowercase": "siz",
    "joined_challenge_on_team": "%{team_name} adlı ekipte bir yarışmaya katıldınız.",
    "join_team": "Bir ekibe katılın",
    "former_members": "Eski üyeler",
    "letsGo": "Hadi başlayalım",
    "invite_to_team": "Ekibe davet et",
    "connectingDeviceToast": {
        "success": {
            "title": "Bir uygulama veya cihaz bağlama",
            "message": "Başarılı! Uygulamanız veya cihazınız bağlandı."
        },
        "danger": {
            "title": "Bir uygulama veya cihaz bağlama",
            "message": "Eyvah… Bu hizmete bağlanırken bir sorun yaşadık. Lütfen tekrar deneyin."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Bir uygulamanın veya cihazın bağlantısını kesme",
            "message": "%{name} bağlantısını başarıyla kestiniz."
        },
        "danger": {
            "title": "Bir uygulamanın veya cihazın bağlantısını kesme",
            "message": "Eyvah… %{name} bağlantısını keserken bir sorun yaşadık. Lütfen tekrar deneyin."
        }
    },
    "leave_entity_question": "Şuradan ayrılmak istiyor musunuz: %{name}?",
    "delete_entity_question": "%{name} silinsin mi?",
    "leave_team_challenge_confirmation": "Bu yarışmada %{name} adlı ekipten ayrılmak istediğinizden emin misiniz?",
    "leave_last_team_member": "Ekibin son üyesi olarak bu yarışmadan ayrılmanız durumunda ekip silinir.",
    "oops_msg": "Eyvah... Bu eylemi tamamlamaya çalışırken bir hata oluştu. Lütfen tekrar deneyin.",
    "has_been_created": "Yarışmaya %{name} ekibinde katıldınız.",
    "specify_team_name": "Lütfen bir ekip adı belirtin",
    "invite_members": "Üye davet et",
    "upload_photo_no_question": "Bir fotoğraf ekleyin",
    "my_progress": "İlerlemem",
    "rewardsPointsAdditionalInfo": "Her %{period} içinde ulaştığınız her seviye için %{reward_currency} kazanın. %{customPoints} ve seviyeleriniz her %{period} bitiminde yeniden başlar. Böylece son dönemde en yüksek seviyeye ulaşmış olsanız bile %{reward_currency} kazanmaya devam etme fırsatınız olur.",
    "rewardsPointsInfo": "%{customPoints} ve ilerlemeniz şu sıklıkla sıfırlanır: %{period}.",
    "departments": "Departmanlar \/ Bölümler",
    "regions": "Bölgeler",
    "noItemsSelected": "Hiçbir öğe seçilmedi",
    "pleaseSelectOne": "Lütfen listeden en az bir öğe seçin",
    "tracked": "Takip edildi",
    "starts": "Başlar",
    "duration": "Süre",
    "bonus": "Bonus",
    "invited_by": "Davet eden:",
    "create_team": "Bir ekip oluşturun",
    "discardConfirmation": "Çıkmak istediğinizden emin misiniz?",
    "discardYes": "Evet",
    "discardStay": "Geri dön",
    "create_team_toast_title": "Ekip oluşturun",
    "edit_team": "Ekibi düzenle",
    "team_edits_submitted": "Ekibiniz güncellendi.",
    "challenge_ended_still_trackable": "Bu %{type} sona erdi. Neyse ki takip edebileceğiniz %{num} gününüz daha var.",
    "tracking_period_ended": "Bu %{type} için takip süresi sona erdi.",
    "unlimited": "Sınırsız",
    "ends_in": "Sona erme:",
    "challenge_toast": {
        "success": {
            "join": "Başarılı!",
            "message": "Yarışmaya başarıyla katıldınız."
        },
        "danger": {
            "error": "Hata",
            "message": "Bir şeyler ters gitti. Kısa bir süre sonra yarışmaya tekrar katılmayı deneyin."
        }
    },
    "members_to_invite": "Davet edilecek üyeler",
    "members_to_remove": "Çıkarılacak üyeler",
    "myChallenges": "Müsabakalar",
    "upcoming": "Yaklaşan",
    "myPersonalGoals": "Amaçlar",
    "companyCompetitions": "Şirket müsabakaları",
    "communityCompetitions": "Topluluk müsabakaları",
    "edit_your_team": "Ekibinizi düzenleyin",
    "emails": "E-postalar",
    "CompletedOverall": "Genel olarak tamamlanan",
    "TotalEarned": "Toplam kazanılan",
    "notify_header": "Bildirim almak istiyorum:",
    "AdditionalBonus": "Ek bonus",
    "goalEndedNotification": "Amaç sona erdi. Sınırlarınızı zorlamaya devam edin.",
    "compEndedNotification": "Müsabaka sona erdi. Sınırlarınızı zorlamaya devam edin.",
    "congrats_tracking_first": "İlk aktivitenizi takip ettiğiniz için tebrikler.",
    "keep_tracking": "Amaçlarınıza ulaşmak ve seviyenizi yükseltmek için aktivitelerinizi takip etmeye devam edin.",
    "understanding_tracking": "Takibi anlama",
    "cannot_track_this_day": "Bu günde takip yapamazsınız.",
    "nothing_tracked_this_day": "Bu günü henüz takip etmediniz.",
    "tracked_something_this_day": "Bugün için bir şey takip ettiniz.",
    "reached_goal_this_day": "Bu günlük amacınıza ulaştınız (sadece günlük amaçlar için).",
    "got_it": "Anladım!",
    "notDismissedMultiTitle": "Yarışma özeti",
    "notDismissedMultiSubtitle": "Birkaç yarışma sona erdi. Her birini nasıl başardığınıza dair ayrıntılar için daha derinlemesine inceleyin. ",
    "daySummary": "%{userName}, işte gününüzün şu ana kadarki özeti",
    "goals": "Amaçlar",
    "competitions": "Müsabakalar",
    "totalAccumulated": "Toplam birikmiş",
    "tracking_for_date": "%{date} için takip",
    "activity_tracker_instruction": "Manuel olarak takip edilen bir aktiviteyi düzenlemek veya kaldırmak için dokunun",
    "ended": "Bitti",
    "notYetAvailableBeta": "Henüz beta sürümünde mevcut değil",
    "suggestedGoal": "Önerilen amaç",
    "singleFor": "şunun için:",
    "seeLessLongComment": "Daha azını gör",
    "synced_data": "Senkronize edilen veriler:",
    "doThisLater": "Bunu daha sonra yapacağım",
    "inviteUsers": "Başkalarını katılmaya davet edin",
    "cannotTrackAfterDeadline": "Yarışmanın son tarihinden sonraki bir tarihe ait bir aktiviteyi takip etmeye çalışıyorsunuz.",
    "potentialBonusPoints": {
        "section": {
            "title": "Bu amaç için %{potentialBonusPoints} bonus %{customPoints} mevcut.",
            "titleNotCompleted": "%{potentialBonusPoints} bonus %{customPoints} ödülü %%{activitytCompletedPercentage} ile kaçırdınız.",
            "titleCompleted": "Tebrikler! Kazandıklarınız:",
            "titleCompletedBold": "%{potentialBonusPoints} bonus %{customPoints}!",
            "subtitle": "Bonus %{customPoints} hakkında daha fazla bilgi edinin"
        },
        "modal": {
            "title": "Bonus %{customPoints}",
            "desc1": "Hiç kimsenin mükemmel olmadığını ve amaçlarını her zaman %100 tamamlayamayacağını biliyoruz.",
            "desc2": "Bu nedenle, genel ilerlemeniz %85 veya üzerinde olduğunda bonus %{customPoints} veriyoruz.",
            "desc3": "Tüm bonus %{customPoints}, amaç sona erdikten sonra verilir ve tüm takibiniz bağlı bir uygulama veya cihazdan yapıldıysa iki kat bonus %{customPoints} alırsınız.",
            "desc4": "Erken ayrıldığınız amaçlar için bonus %{customPoints} alamazsınız."
        },
        "msg": {
            "title": "Bu amaç sona erdi",
            "subtitle": "Amaç %{goalEndedDate} tarihinde sona erdi"
        },
        "msgEnded": {
            "title": "Zaman doldu. Amacınız sona erdi",
            "subtitle": "Aktivitenizi takip etmek için %{daysNum} %{daysOrDay} süreniz var."
        }
    },
    "finish": "Bitir",
    "personalGoal": {
        "all_goals": {
            "selected": "%{maxGoals} amacın tümü belirlendi!",
            "description": "Bu hoşunuza gidiyor mu? Fikrinizi değiştirirseniz amaçların herhangi birini değiştirebilirsiniz. Endişelenmeyin, amacı daha sonra iptal edebilirsiniz.",
            "set": "Tüm amaçlar belirlendi.",
            "action": "Her şey hazır, devam edebiliriz.",
            "error": "Kendimizi kaptırmayalım. Bir seferde en fazla 3 yapılandırılmış amaca odaklanmak başarı olasılığınızı artıracaktır.",
            "errorHeading": "Amaç belirleme"
        },
        "set_more": "%{maxGoals} tane daha aktif amaç belirleyebilirsiniz",
        "select_goal": {
            "heading": "Önerilen bir amacı belirleyin veya kendinizinkini oluşturun"
        },
        "set_more_1": "1 tane daha aktif amaç belirleyebilirsiniz"
    },
    "restartPersonalGoal": "Amacı yeni hedeflerle yeniden başlatın",
    "delete_challenge_confirmation": "Bu yarışmayı silmek istediğinizden emin misiniz?",
    "personal_goal_unit": "amaç",
    "personal_goal_units": "amaç",
    "day_summary": {
        "steps_taken": "Atılan adımlar",
        "calories_in": "Alınan kaloriler",
        "calories_out": "Harcanan kaloriler",
        "avg_daily": "ort. günlük",
        "most_earned_daily": "bir günde en çok kazanılan"
    },
    "invitedBy": "%{person} tarafından davet edildi",
    "resetPasswordMissingField": "Lütfen bir e-posta adresi girin",
    "resetPasswordInvalidValue": "Lütfen geçerli bir e-posta adresi girin",
    "resetPasswordNotFound": "E-posta adresiniz bulunamadı",
    "resetPasswordNotCompleted": "Talebiniz tamamlanamadı",
    "resetGoalInstructions": {
        "start": "%{quantity} %{units} %{activity} yapın",
        "additional": ", %{quantity} %{units} %{activity}",
        "end": "%{frequency} ve %{points} %{customPoints} %{frequency} kazanın"
    },
    "goalSet": {
        "one": "Bir amaç belirlendi. Görüntüleyin",
        "two": "İki amaç belirlendi. Görüntüleyin",
        "three": "Üç amaç belirlendi. Görüntüleyin",
        "none": "Hiçbir amaç belirlenmedi. Amaç belirleyin"
    },
    "searchCommunitiesEmpty": "Hiçbir topluluk bulunamadı",
    "searchCommunitiesPlaceholder": "Toplulukları arayın",
    "updating": "Güncelleniyor...",
    "pts_tracked": "Takip edilen %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "İyi iş çıkardınız, böyle devam! İyilik hali puanınızı iyileştirme yolunda ilerliyorsunuz.",
    "progressHistory": "İlerleme geçmişi",
    "privateCommunity": "Bu özel bir topluluktur",
    "do_combo_of_activities": "Aşağıdakilerin bir veya birkaçını yapın.",
    "noActivitiesTracked": "Takip edilen aktivite yok",
    "trackingWithFollowingApps": "Aşağıdaki uygulamalar \/ cihazlar ile takip",
    "recommendedApps": "Bu %{challengeType} için önerilen uygulamalar \/ cihazlar",
    "collapseWord": "Daralt",
    "started": "Başlangıç:",
    "ends": "Sona erme:",
    "do_activities": "Aktivite yapın",
    "rewards_placeholder": "Mağazadan örnek ödüller, yer tutucu. Kullanıcılar satın alabilecekleri çeşitli ürünleri ve %{rewardName} cinsinden maliyeti görecekler.",
    "personalGoals": {
        "top": {
            "label": "En Üstte"
        },
        "allGoals": "Tüm amaçlar",
        "seeMoreCard": {
            "heading": "Aradığınızı bulamadınız mı?",
            "description": "Önerilen tüm amaçlara göz atın",
            "button": "Amaçları keşfedin"
        }
    },
    "rewardsNotAvailable": "Ödüller şu anda bu beta sürümünde kullanıma sunulmuş değil. Kullanıma sunulduğunda, kataloğu görüntüleyebilir ve kullanım işlemlerini tamamlayabilirsiniz.",
    "editProfileProvideRestingHeartRate": "Lütfen en az 40 olan geçerli bir dinlenme kalp atış hızı değeri sağlayın",
    "liveBetterHealthInfo": "Bir dizi program yürütüyoruz ve çeşitli sağlık ihtiyaçlarını desteklemek ve sağlığınızı iyileştirmenize yardımcı olmak için tasarlanmış çeşitli sağlık içeriklerimiz var. Henüz her sağlık sorunu ve ihtiyacı için programlarımız yok, ama bu konuda çalışıyoruz. Aşağıdaki soruları yanıtlarsanız ve katılımınızdan faydalanabileceğiniz herhangi bir sağlık programı veya hizmeti tespit edersek, sizinle iletişime geçer ve\/veya sağlık ihtiyaçlarınızı daha iyi anlamanıza ve yönetmenize yardımcı olacak kanıta dayalı bilgiler göndeririz. Lütfen bu bilgileri poliçenizin uygunluğunu değerlendirmek için kullanmadığımızı unutmayın. Kapsamınızı öğrenmek istiyorsanız veya poliçenizle ilgili herhangi bir sorunuz varsa 132 331 numaralı telefondan Müşteri Bağlantı ekibimizi arayabilirsiniz.",
    "deleteGoalToast": {
        "success": {
            "title": "",
            "message": "Amacı sildiniz"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "",
            "message": "Yarışmayı sildiniz"
        }
    },
    "invitations": "Davetler",
    "learnMorePeriods": "Dönemler hakkında daha fazla bilgi edinin",
    "tracked_by_app_name": "%{app_name} tarafından takip ediliyor",
    "device_required": {
        "text": "Bu %{challengeType} için bir uygulama veya cihaz gerekli",
        "button": "Bir uygulama veya cihaz bağlayın"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Topluluğu düzenle",
            "message": "Topluluk düzenlendi"
        }
    },
    "competition": "Müsabaka",
    "close": "Kapat",
    "only_automatic_activities_with_device": "Bu %{goal_or_competition} aktiviteleri bağlı uygulamalarınız \/ cihazlarınız ile otomatik olarak takip edilir.",
    "only_automatic_activity_with_device": "Bu %{goal_or_competition} aktivitesi bağlı uygulamalarınız \/ cihazlarınız ile otomatik olarak takip edilir.",
    "deletingCommunityToast": {
        "success": {
            "title": "",
            "message": "Topluluk silindi"
        }
    },
    "teamSizeMessage": "Yarışmada %{customPoints} kazanmak için ekibinizin en az %{min} kişiye ihtiyacı var.",
    "captain": "Kaptan",
    "inviteOthersToTeam": "Başkalarını ekibime davet et",
    "loadingMetrics": "Gününüzü güncellemek için kaynaklara bağlanıyorsunuz...",
    "aboutTeamSize": {
        "title": "Ekip büyüklüğü",
        "text": "%{min} - %{max}"
    },
    "pointsOverview": "%{customPoints} için genel bakış",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Talebiniz tamamlanamadı",
        "error": "Hata"
    },
    "required_lc": "gerekli",
    "personal": "Kişisel bilgiler",
    "biometrics": "Biyometri",
    "makeSelection": "Bir seçim yapın",
    "ask_question_success_msg": "Teşekkür ederiz. Mümkün olan en kısa sürede cevap vereceğiz.",
    "report_issue_success_msg": "Teşekkür ederiz. Mümkün olan en kısa sürede cevap vereceğiz.",
    "ask_question_success_title": "Soru gönderildi",
    "report_issue_success_title": "Teknik sorun bildirildi",
    "ask_question_failure_msg": "Tüh... Sorunuz gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
    "report_issue_failure_msg": "Tüh... Sorununuz bildirilirken bir hata oluştu. Lütfen tekrar deneyin.",
    "notTrackedActivities": "Bu dönem için herhangi bir aktiviteyi izlemediniz",
    "learn": "Öğren",
    "Balance": "Denge",
    "details": "Ayrıntılar",
    "Reward": "Ödül",
    "levelsReset": "Seviyeler %{remainingDays} gün sonra sıfırlanacak",
    "redeem": "Kullan",
    "redeemAt": "%{points} sınırında kullan",
    "needPointsToRedeem": "%{points} daha %{rewardName} ödülüne ihtiyacınız var.",
    "learnEarnMore": "Nasıl daha fazla kazanacağınızı öğrenin",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Ekibe katıl",
            "message": "Ekibe başarıyla katıldınız."
        },
        "danger": {
            "message": "Bir hatayla karşılaştık ve ekibi bulamadık. Artık mevcut olmayabilir."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Eylem mevcut değil",
            "message": "Talebiniz tamamlanamadı."
        }
    },
    "transactionLog": "İşlemler",
    "orderHistory": "Siparişler",
    "pointsAvailableToEarn": "%{points} kazanılabilir",
    "missedYTD": "%{missed} kaçırılan YTD",
    "rewardsDetails": "Ödüller",
    "successfullyRedeemedItem": "Bu öğeyi başarıyla kullandınız",
    "orderNumber": "Sipariş numarası",
    "amountSpent": "Harcanan miktar",
    "status": "Durum",
    "dateRedeemed": "Kullanıldığı tarih",
    "additionalInformation": "Ek bilgiler",
    "shipToAddress": "Bu adrese gönder",
    "pointMissedYearToDate": "%{rewardCurrencyName} bu yıl kaçırıldı",
    "pointMissedYearToDateDescription": "Bir seviyeye dönem bitmeden ulaşamadığınızda, kazanabileceğiniz ilgili %{rewardCurrencyName} kaçırılmış olarak kabul edilir.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Makale bulunamadı",
            "message": "Makale bulunamadı. Kaldırılmış olabilir veya artık mevcut olmayabilir."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Topluluk bulunamadı",
            "message": "Topluluk bulunamadı. Kaldırılmış olabilir veya artık mevcut olmayabilir."
        }
    },
    "shippingAddress": "Gönderim \/ fatura adresi",
    "enterShippingAddress": "Gönderim \/ fatura adresinizi girin",
    "streetLine": "Sokak satırı %{num}",
    "stateProvince": "Eyalet \/ İl",
    "postcodePostalcodeZip": "Posta kodu",
    "phoneNumber": "Telefon numarası",
    "order": "Sipariş",
    "redemptionConfirmation": "Kullanım onayı",
    "edit": "Düzenle",
    "processing": "İşleniyor",
    "checkIsYouFirst": "Önce kimliğinizi kontrol etmemiz gerekiyor",
    "discardSomeGoals": "Bazı amaçlar belirlediniz. Devam ederseniz bu amaçlar iptal edilecektir.",
    "settingGoalsToast": {
        "success": {
            "message": "Yeni hedefleriniz belirlendi."
        }
    },
    "one_team": "1 ekip",
    "noAchievementsToEarnMessage": "Bu dönemde %{rewardCurrencyName} kazanılabilecek başka rozet yok gibi görünüyor.",
    "shopRewards": "Mağaza ödülleri",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Gönderim \/ fatura adresi",
            "message": "Lütfen devam etmeden önce tüm alanları doldurun."
        }
    },
    "viewDetails": "Ayrıntıları görüntüle",
    "potential": "Potansiyel",
    "missed": "Kaçırıldı",
    "rewardsStoreNotAvailable": "Ödül mağazası şu anda sizin için kullanılabilir durumda değil.",
    "havent_tracked_in_a_while_date": "%{currentDate} için hiçbir aktivite takip edilmiyor",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Yarışma bulunamadı",
            "message": "Yarışma bulunamadı. Kaldırılmış olabilir veya artık mevcut olmayabilir."
        }
    },
    "shareYourDaySubtitleActivity": "Bu aktivite hakkında bir resim ekleyin veya bir şeyler söyleyin.",
    "goal_ended": "Amaç sona erdi",
    "challenge_ended": "Yarışma sona erdi",
    "day_remaining_to_track": "Kaçırdığınız herhangi bir aktiviteyi takip etmek için 1 gününüz var",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} %{endDate} tarihinde sona erdi",
    "goalEndedModal": {
        "title": "Unutulan aktiviteyle arayı kapatın",
        "message": "Kişisel bir amaç veya yarışma sona erdikten sonra, unutmuş olabileceğiniz herhangi bir aktiviteyi takip etmek için bitiş tarihinden itibaren üç gününüz vardır. Bu süreden sonra, amaca veya yarışmaya katkıda bulunan herhangi bir ek aktiviteyi takip edemezsiniz."
    },
    "summary": "Özet",
    "placedRank": "%{total} içinde %{rank}. sıradasınız",
    "rank": {
        "first": "1.",
        "second": "2.",
        "third": "3.",
        "n": "%{rank}."
    },
    "event_name": "Etkinlik adı",
    "this_is": "Bu bir  ",
    "location_info": "Konum ve bilgi",
    "what_event": "Bu etkinlik ne hakkında?",
    "event_is": "Bu etkinlik",
    "start_on": "Başlangıç zamanı:",
    "end_on": "Bitiş zamanı:",
    "location": "Konum",
    "chooseLeaderboard": "Bir puan tablosu seçin",
    "filterOneOfFollowing": "Aşağıdakilerden birini filtreleyin",
    "showChallengeInstead": "Bunun yerine bir yarışma göster",
    "showActivityInstead": "Bunun yerine bir aktivite göster",
    "showAll": "Tümünü göster",
    "activitiesShowSame": "Aktiviteler: %{activityName}",
    "challengeShowSame": "Yarışma: %{challengeName}",
    "chooseTimePeriod": "Bir dönem seçin",
    "youCanFilterOneAtTime": "Aynı anda bir filtre seçilebilir",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Sağlık konuları kaydedildi",
            "title": "Başarılı!"
        },
        "info": {
            "message": "Kaydedilemedi"
        },
        "danger": {
            "title": "Hata!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Sağlık hedefleri kaydedildi",
            "title": "Başarılı!"
        },
        "info": {
            "message": "Kaydedilemedi"
        },
        "danger": {
            "title": "Hata!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "İlgi alanları kaydedildi",
            "title": "Başarılı!"
        },
        "info": {
            "message": "Kaydedilemedi"
        },
        "danger": {
            "title": "Hata!"
        }
    },
    "edit_event": "Etkinliği düzenle",
    "leave": "Ayrıl",
    "delete_event": "Etkinliği sil",
    "no_events": "Etkinlik yok",
    "no_events_placeholder": "Şu anda gelecekteki herhangi bir etkinliğe katılmayı planlamıyorsunuz. Neden birine katılmıyorsunuz?",
    "event": "etkinlik  ",
    "challenge": "Yarışma",
    "invited_you": "Sizi davet etti",
    "public": "Genel",
    "private": "Özel",
    "deleteEventToast": {
        "success": {
            "title": "",
            "message": "Etkinlik başarıyla silindi."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "",
            "message": "Etkinlikten ayrıldınız"
        }
    },
    "editEventToast": {
        "success": {
            "title": "",
            "message": "Etkinlik başarıyla güncellendi."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Etkinlik başarıyla oluşturuldu.",
            "title": ""
        }
    },
    "contentIsDeletedOrInappropriate": "Görüntülemeye çalıştığınız içerik şu anda mevcut değil. Yazar tarafından silinmiş veya uygunsuz olarak işaretlenmiş olabilir.",
    "start_time": "Başlangıç Zamanı",
    "end_time": "Bitiş Zamanı",
    "event_type": "%{eventType} etkinliği",
    "leave_event_modal": {
        "title": "Bu etkinlikten ayrılırsanız",
        "message": "Silinecek"
    },
    "leave_event ": "Bu etkinlikten ayrılmak istediğinizden emin misiniz?",
    "create_event": "Etkinlik oluştur",
    "created_by": "Oluşturan",
    "eventActionToast": {
        "danger": {
            "title": "Hata",
            "message": "Bir şeyler ters gitti. "
        }
    },
    "continue": "Devam et",
    "wantExitTour": "Turdan çıkmak istediğinizden emin misiniz?",
    "exitTour": "Turdan çık",
    "deleveEventPopup": "Bu etkinliği silmek istediğinizden emin misiniz?",
    "attendeesTitle": "Katılımcılar",
    "userEvents": "%{name} adlı kişinin etkinlikleri",
    "createEventIndicator": "Etkinlik oluşturuluyor",
    "inviteToEvent": "Etkinliğe davet et",
    "noDescription": "Açıklama yok.",
    "leaderboardIsEmpty": "Bu puan tablosu boş veya görüntülemek için seçili zaman aralığında aktiviteyi takip etmeniz gerekebilir",
    "notParticipantingInAnyChallenges": "Hiçbir yarışmaya katılmıyorsunuz",
    "buttonLeaveEvent": "Etkinlikten ayrıl",
    "leaveEvent ": "Şuradan ayrılmak istiyor musunuz: %{name}?",
    "canceledCreatingChallenge": "%{challengeType} oluşturma işlemi başarıyla iptal edildi",
    "swipeReadNotification": "Okuyun",
    "productTour": {
        "initialScreen": {
            "title": "%{programName} programına hoş geldiniz.",
            "body": "Hadi bir tura çıkalım. Birkaç dakika içinde temel bilgileri öğreneceksiniz."
        },
        "dashboard": {
            "title": "Pano",
            "body": "Kaç %{pointsName} puanınız olduğunu ve seviyelerdeki ilerlemenizi görün. Sonra sıralamanızı görmek için puan tablosuna göz atın."
        },
        "rewards": {
            "title": "Ödüller",
            "body": "Kaç %{rewardPointName} puanınız olduğunu görün ve bunları mağazada kullanın."
        },
        "goals": {
            "title": "Amaçlar ve yarışmalar",
            "body": "Aktif kişisel hedefleriniz, başkalarıyla birlikte olan yarışmalarınız ve özel görevleriniz burada bulunabilir."
        },
        "explore": {
            "title": "Keşfet",
            "body": "Başkalarıyla birlikte yarışmaların üstesinden gelin, ilgi alanlarınızı tartışmak için topluluklara katılın ve sağlıklı yaşam kütüphanesinde yeni bir makale keşfedin."
        },
        "me": {
            "title": "Ben",
            "body": "İyilik hali puanınızı bulun, istatistiklerinizi kontrol edin ve profilinizi ve ayarlarınızı buradan düzenleyin."
        },
        "finishScreen": {
            "title": "Artık hazırsınız",
            "body": "Turu tamamladığınız için teşekkür ederiz.",
            "button": "Hadi başlayalım"
        },
        "skip": {
            "title": "Turu atlamak istediğinizden emin misiniz?",
            "body": "Turunuz böylece sona erecek ve hemen başlayabilirsiniz."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Kimlik doğrulama hatası",
            "message": "Ödül kullanımı işlemine devam edilemedi. Ödül sağlayıcısı ile kimlik doğrulaması yapılırken bir hata oluştu."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "Kullanım başarısız oldu",
            "message": ""
        }
    },
    "disclamerSectionTitle": "Başlamadan önce",
    "disclamerSectionMessage": "Yeni bir egzersiz programına başlamadan veya yaşam tarzınızda değişiklik yapmadan önce bunların size uygun olduğundan emin olmak için sağlık uzmanınıza danışın.",
    "noEarchedAchievements": "Henüz herhangi bir başarı kazanmadınız. Başlamak için bir aktiviteyi takip edin.",
    "noInProgressAchievements": "Devam eden başarınız bulunmamaktadır.",
    "discardCreatingEventMessage": "Gerekli tüm alanların doldurulup doldurulmadığını kontrol edin",
    "discardCreatingEventTitle": "Etkinlik oluşturulamıyor",
    "discardEditedEventTitle": "Etkinlik düzenlenemez",
    "errorEventNameMessage": "Ad gereklidir",
    "errorEventStartDateMessage": "Başlangıç tarihi gereklidir",
    "errorEventEndDateMessage": "Bitiş tarihi gereklidir",
    "errorEventDateMessage": "Bitiş tarihi başlangıç tarihinden daha erken olamaz",
    "noAccountsToLink": "%{program_name} programına bağlanabilecek hesap bulunmamaktadır.",
    "accountLinkEmailChanged": "E-posta adresiniz güncellendi. Bundan sonra bağlantılı hesabınızla oturum açın.",
    "accountLinkSuccessful": "Hesabınız başarıyla bağlandı.",
    "edit_profile_nan_value": "Değer bir sayı olmalıdır",
    "advancedLogIn": "Gelişmiş giriş",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "Kullanım başarısız oldu",
            "message": "Sipariş oturumu sona erdi. Lütfen tekrar sipariş vermeyi deneyin."
        }
    },
    "left": "kaldı",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Görünüşe göre şu anda katılabileceğiniz hiçbir etkinlik yok. Neden bir tane oluşturmuyorsunuz?"
        }
    },
    "reachedHighestLevel": "En üst seviyeye ulaştınız.",
    "error": "Hata",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Ödül kullanımı",
            "message": "Siparişiniz verildi"
        }
    },
    "redeemRewardComplete": "Kullanım tamamlandı",
    "trackActivityTitle": {
        "oneUnit": "Takip edin: %{date} tarihinde 1 %{unit} %{activity}",
        "nUnit": "Takip edin: %{date} için %{activity}"
    },
    "ssoAuthenticationFailure": "Kimlik doğrulama hatası",
    "earnEvery": "Şu sıklıkla kazanın: %{frequency}",
    "earnOnce": "Sadece bir kez kazanın",
    "goalSettings": {
        "maximumSet": "Şu anda 3 olarak belirlenmiş olan maksimum sayıda amacınız mevcut.",
        "learnMore": "Amaç belirleme hakkında daha fazla bilgi edinin"
    },
    "allowMarketingComms": "Bana promosyon mesajları gönder",
    "allowPartnerMarketingComms": "Bana ortaklardan gelen promosyon mesajlarını gönder",
    "noUpcomingAchievements": "Yaklaşan başarınız yok.",
    "settingGoalToast": {
        "success": {
            "message": "Yeni amacınız belirlendi."
        }
    },
    "authentication": {
        "saml": {
            "error": "Hizmet şu anda kullanılamıyor",
            "signin": "Bütünleşik oturum açma",
            "signup": "Bütünleşik kayıt"
        }
    },
    "monthName": {
        "january": "Ocak",
        "february": "Şubat",
        "march": "Mart",
        "april": "Nisan",
        "may": "Mayıs",
        "june": "Haziran",
        "july": "Temmuz",
        "august": "Ağustos",
        "september": "Eylül",
        "october": "Ekim",
        "november": "Kasım",
        "december": "Aralık"
    },
    "promotedForMe": "Öne çıkan",
    "appRating": {
        "enjoying": "Uygulamamızı beğeniyor musunuz?",
        "feedback": "Geri bildirimde bulunmak ister misiniz?",
        "appStore": "App Store'da bizi değerlendirir misiniz?",
        "googlePlay": "Google Play'de bizi değerlendirir misiniz?",
        "notReally": "Pek sayılmaz",
        "yes": "Evet",
        "sure": "Elbette",
        "noThanks": "Hayır, teşekkürler",
        "notNow": "Şimdi değil"
    },
    "getMobileApp": "Akıllı telefonunuzda %{programName} uygulamasını kullanmak için App Store veya Google Play'den %{appStoreName} uygulamasını indirin.",
    "newAppsDevicesDesign": {
        "getMobileApp": "%{programName} uygulamasını indirin",
        "searchInAppStore": "Cihazınızın uygulama mağazasında %{programName} programını arayın",
        "getMobileAppNoName": "Mobil uygulamayı edinin"
    },
    "editorAlert": {
        "discardChanges": "Değişiklikleri iptal et",
        "saveAndContinue": "Kaydet ve devam et",
        "title": "Kaydedilmemiş değişiklikler",
        "text": "Kaydedilmemiş bazı değişiklikler yaptınız. Ne yapmak istersiniz?"
    },
    "resources": "Kaynaklar",
    "noResources": "Kullanılabilir kaynak yok",
    "viewAllResources": "Tüm kaynakları görüntüle",
    "language": "Dil",
    "eventStarted": "Etkinlik başladı. Kayıtlar kapandı.",
    "Gender": "Doğumda atanan cinsiyet",
    "show": "Göster",
    "hide": "Gizle",
    "timeoutError": "Eyvah! Bir şey çok uzun sürüyor. Lütfen daha sonra tekrar deneyin.",
    "SOT": {
        "sample_task": "Örnek Görev"
    },
    "cache": {
        "new_version": "Yeni bir sürüm mevcut.",
        "refresh_browser": "Tarayıcınızı yenilemek için buraya tıklayın."
    },
    "welcomeUser": "Hoş geldin %{userFirstName}!",
    "quarter": "çeyrek",
    "completionReward": "Tamamlama ödülü",
    "bronzeLevel": "Bronz seviye",
    "deviceAppSyncingOk": "Cihaz \/ uygulama senkronizasyonu tamam",
    "deviceAppSyncingIssue": "Cihaz \/ uygulama senkronizasyon sorunu",
    "deviceAppSyncingError": "Cihaz \/ uygulama senkronizasyon hatası",
    "lastSync": "Son senkronizasyon",
    "period": "dönem",
    "yourDaySummary": "Gününüz (şu ana kadar)",
    "steps": "Adımlar",
    "gender_non_binary": "Non-binary veya non-conforming",
    "take_survey": "Ankete katılın",
    "social": "Sosyal",
    "finalDay": "Son Gün",
    "leaderboard_position": "Puan tablosundaki konumu",
    "signUp": {
        "apple": {
            "disconnectSettings": "Kaydolmaya devam etmek için Telefon Ayarları'ndaki \"Apple Kimliği Parola ve Güvenlik\"ten %{appName} uygulamasının bağlantısını kesin"
        }
    },
    "earnPoints": "%{customPoints} kazanın. Seviye atlayın.",
    "getReward": "%{rewardName} alın.",
    "buildHealthyHabits": "Sağlıklı alışkanlıklar edinin.",
    "highestLevelIndicator": "En üst seviyeye ulaştınız.",
    "highestLevelIndicatorNew": "Her seviyeyi tamamladınız.",
    "trackYourActivity": "%{customPoints} kazanmak için egzersizinizi ve sağlıklı yaşam aktivitelerinizi takip edin.",
    "levelUpToGetRewarded": "Seviye atladıkça %{rewardName} ile ödüllendirileceksiniz.",
    "levelUpAndEarn": "İlerlemeniz şu sıklıkla sıfırlanır: %{period}. Böylece tekrar tekrar seviye atlayıp kazanabilirsiniz.",
    "levelUp": "İlerlemeniz şu sıklıkla sıfırlanır: %{period}. Böylece tekrar tekrar seviye atlayabilirsiniz.",
    "goToLibrary": "Kütüphaneye git",
    "updateEventIndicator": "Etkinlik güncelleniyor",
    "meTour": {
        "healthSurveyDisabled": "İstatistiklerinizi kontrol edin ve profilinizi ve ayarlarınızı buradan düzenleyin."
    },
    "createNewGoal": "Yeni amaç oluşturun",
    "later": "Daha sonra",
    "bonusChallenge": "Bonus yarışma",
    "bonusChallengeInfo": {
        "withReward": "Bu %{challengeType} yarışmanın en az %85'ini tamamladığınızda %{amount} bonus %{points} kazanacaksınız.",
        "noReward": "Bu yarışmanın en az %85'ini tamamladığınızda bonus kazanacaksınız.",
        "boldText": "%{amount} bonus %{points}",
        "noRewardChallengeType": "Bu %{challengeType} yarışmanın en az %85'ini tamamladığınızda bonus kazanacaksınız."
    },
    "defaultApp": "Varsayılan sağlık uygulamanız",
    "bonusGoal": {
        "additionalInfo": "Tüm aktiviteniz bağlı bir uygulama veya cihaz kullanılarak izlendiyse iki kat bonus %{points} kazanacaksınız.",
        "additionalInfoNew": {
            "paragraph2": "Bonus %{points}, amaç sona erdikten sonra verilir. Erken bıraktığınız amaçlar için bonus %{points} almazsınız."
        },
        "boldText": "çi̇fte bonus %{points}!",
        "markTitle": "Bonus amaç"
    },
    "notify_me": "Bana haber ver",
    "bonusChallengeReward": "Bonus yarışma ödülü",
    "forCompletingChallenge": "%{challengeName} yarışmasını tamamladığınız için",
    "notifications_text": "Bildirimler amaçlarınıza bağlı kalmanıza ve konuşmaları takip etmenize yardımcı olur.",
    "type_here": "Buraya yazın",
    "bonusEarned": "Kazanılan bonus",
    "youEarnedBonus": "Bu bonusu kazandınız.",
    "inviteOthersToChallenge": "Başkalarını yarışmaya katılmaya davet edin",
    "inviteOthersToYourTeam": "Başkalarını ekibinize davet edin",
    "manageTeam": "Ekibi yönet",
    "ft": "ft",
    "lbs": "lb",
    "cm": "cm",
    "kg": "kg",
    "community": "topluluk",
    "chooseActivity": "Aktivite seçin",
    "Recent": "Yeni",
    "noActivities": "Eşleşen aktivite yok",
    "photoChooseText": "Seçin",
    "photoCancelText": "İptal et",
    "signIn": {
        "missingEmail": "Eksik e-posta adresi",
        "missingPassword": "Lütfen parolanın sağlandığından emin olun",
        "invalidLogin": "Hatalı e-posta veya parola",
        "accountLocked": "Hesabınız kilitlendi. Lütfen yöneticinizle iletişime geçin",
        "accountMayNotExist": "Bu e-posta adresi için bir hesabımız yok. Hesap oluşturmak için kaydolun.",
        "wrongPassword": "Yanlış parola. Tekrar deneyin veya sıfırlamak için Parolamı Unuttum'a tıklayın."
    },
    "deleteGoalBonusPoints": "İlgili bonusu henüz kazanmadıysanız artık kazanamayacaksınız.",
    "havent_tracked_goal": "Bu amaç için hiçbir aktivite izlemediniz",
    "trackActivity": {
        "search": "Aktiviteleri arama...",
        "text": "Aktiviteyi takip edin",
        "done": "Bitti",
        "discardChanges": "Değişiklikler iptal edilsin mi?",
        "discardMessage": "Çıkmak ve ilerlemenizi iptal etmek istediğinizden emin misiniz?",
        "discard": "İptal et",
        "limitMessage": "Bir seferde yalnızca yedi güne kadar takip edebilirsiniz.",
        "inputDescription": "%{date} için %{activity} miktarı",
        "gracePeriod": "Kaçırdığınız aktiviteleri takip etmeniz için %{n} %{text} var"
    },
    "dates": "Tarihler",
    "pickDates": "Başka tarihler seçin",
    "selectDates": "Tarihleri seçin",
    "limitReached": "Sınıra ulaştınız",
    "activity": "Aktivite",
    "keepUpTheGoodWork": "İyi iş çıkardınız, böyle devam!",
    "activityTracked": "Aktivite takip edildi",
    "new": "Yeni",
    "newFeatureTitle": "Daha kolay, daha hızlı aktivite takibi",
    "newFeatureText": "Bugünün, geçmişin veya birden fazla günün aktivitelerini takip etmenizden bağımsız olarak bu deneyimi seveceğinizi düşünüyoruz.",
    "gotIt": "Anladım!",
    "frequencyViewHistory": "%{frequency} dökümü görüntüle",
    "challengeDetails": {
        "trackTheseActivities": "Bu %{challengeType} doğrultusunda ilerlemek için bu etkinliklerden herhangi birini takip edin."
    },
    "member": "üye",
    "weeklyBreakdown": "Haftalık döküm",
    "setGoals": {
        "earnPointsText": {
            "start": "Kazanın",
            "end": "--ilk amacınızı belirlediğiniz için."
        }
    },
    "weeklyGoalEnded": "Haftanın sona erdiği zaman:",
    "weekFinished": "Şununla dolu bir haftayı bitirdiniz:",
    "restartGoal": {
        "daysLeftToTrack": "Geçtiğimiz haftadan unutulan ilerlemeleri takip etmek için hâlâ %{quantity} %{days} süreniz var.",
        "weekEnded": "Bu hafta sona erdi.",
        "timesUp": "Zaman doldu.",
        "period": {
            "title": "Amaç dönemi",
            "text": "Pazartesiden pazara, her hafta"
        }
    },
    "membersPlural": "Üye",
    "startedADayAgo": "1 gün önce başladı",
    "goalRestarted": "Bu amacı yeniden başlattınız",
    "weeklyGoals": "Haftalık amaçlar",
    "weeklyGoalsDescription": "Haftalık hedefler her pazartesi kendini yeniler. Böylece sağlıklı bir alışkanlığı uzun süre sürdürebilirsiniz.",
    "challengeEnded": "Bu %{challengeType} sona erdi",
    "goalEndedModalTitle": "Zaman doldu. %{challengeType} sona erdi.",
    "yourProgress": "İlerleme durumunuz",
    "earn_withRewards": "Sağlıklı aktivitenizi takip ederek (%{pts}) kazanın ve seviyeleri geçin. Seviye atladığınızda %{currency} kazanacaksınız.",
    "earn_noRewards": "Egzersizinizi ve sağlıklı yaşam aktivitelerinizi takip ederek (%{pts}) kazanın ve seviye atlayın.",
    "currentPeriod": "Mevcut Dönem",
    "currentScore": "Güncel Puan",
    "viewActivityLog": "Etkinlik günlüğünü görüntüle",
    "balanceHistory": "Bakiye geçmişim",
    "mymedibank": {
        "underAge": {
            "error": "Live Better uygulaması yalnızca 18 yaş ve üzeri kullanıcılara açıktır. Daha fazla bilgi edinmek için lütfen Live Better Hüküm ve Koşulları'na bakın."
        }
    },
    "enhancedHomePageInfo": "Ana sayfayı düzenledik. Yarışmalarınızı ve amaçlarınızı görmek artık daha kolay. Takip etme zamanı!",
    "levelUpTitle": "Seviye atlayın",
    "levelUpDescription": "Aktiviteleri takip ederek ve amaç ile zorlukları tamamlayarak seviyeleri geçin. Seviye atladıkça %{currency} ile ödüllendirileceksiniz.",
    "achievementsDescription": "%{currency} kazanmak için bu özel rozetlerin kilidini açın. Ne yapmanız gerektiğini görmek için bir rozete tıklayın.",
    "bonusChallengesDescription": "Katılın ve %{currency} bonusu olan yarışmaları tamamlayın.",
    "earnWithPartners": {
        "title": "Ortaklarla kazanın",
        "description": "Hastane veya ekstra teminatları olan Medibank üyeleri, ortaklarıyla yaptıkları uygun alışverişlerde\/aktivitelerde puan kazanabilirler."
    },
    "browseAllPartners": "Tüm ortaklara göz atın",
    "resetsIn": "%{daysNumber} gün içinde sıfırlanır",
    "thisIsALot": "Bu çok fazla!",
    "areYouSure": "Emin misiniz?",
    "trackingALotMessage": {
        "days": "%{daysNum} günde 2.000'den fazla %{customPoints} takip ediyorsunuz. Bu oldukça yüksek bir sayı.",
        "day": "Bir günde 2.000'den fazla %{customPoints} takip ediyorsunuz. Bu oldukça yüksek bir sayı."
    },
    "amSure": "Eminim",
    "activeMinutesAndSleep": {
        "title": "Aktif olunan dakikalar ve uyku için cihaz takibi",
        "description": "Cihazınız orta veya yüksek yoğunluklu fiziksel aktivite (kaliteli egzersiz) sırasında aktif olunan dakikaları kaydeder. Uykunuzu takip etmek için bir cihaz kullanıyor musunuz? Bunun için de %{points} kazanacaksınız."
    },
    "hourShort": "sa",
    "hoursShort": "sa",
    "secondsShort": "sn",
    "watchToEarn": "Kazanmak için izleyin",
    "oneParticipant": "1 katılımcı",
    "oneTeam": "1 Ekip",
    "numberOfTeams": "%{num} ekip",
    "inviteToYourTeam": "Ekibinize davet edin",
    "inviteToThisChallenge": "Bu yarışmaya davet edin",
    "challengeInstructionText": "%{challengeType} doğrultusunda ilerlemek için bu aktiviteyi takip edin.",
    "showLess": "Daha az göster",
    "startsTomorrow": "Yarın başlıyor",
    "deadlineDayLeft": "gün kaldı",
    "deadlineDaysLeft": "gün kaldı",
    "deviceBonus": "cihaz bonusu",
    "appsAndDevices": {
        "header": "Uygulamalar ve cihazlar",
        "linked": "Bu bağlantılı uygulamalar ve cihazlar bu %{challengeType} doğrultusunda ilerliyor:",
        "noLinked": "Bağlantılı geçerli uygulama veya cihaz yok",
        "link": "Otomatik olarak takip etmek için telefonunuzu, saatinizi veya uygulamanızı bağlayın."
    },
    "yourGoals": "Amaçlarınız",
    "yourChallenges": "Yarışmalarınız",
    "position": "Pozisyon",
    "team_success": "Ekip başarısı",
    "starts_in": "Başlaması için kalan süre:",
    "team_challenge": "Ekip yarışması",
    "your_progress_today": "Bugünkü ilerlemeniz",
    "your_daily_avarage": "Günlük ortalamanız:",
    "this_week_progress": "Bu haftanın ilerlemesi",
    "this_month_progress": "Bu ayın ilerlemesi",
    "overall_progress": "Genel ilerleme",
    "complete": "tamamlandı",
    "overallSuccess": "Genel başarı",
    "teamSuccessAverage": "Ekip başarısı ortalaması",
    "progressDetails": "İlerleme ayrıntıları",
    "dayStreak": "%{n} günlük seri!",
    "weekStreak": "%{n} haftalık seri!",
    "dailyProgress": "Günlük ilerleme",
    "participantsSuccessCount": {
        "overall": "%{total} katılımcıdan %{amount} tanesi hedefe ulaştı",
        "day": "%{total} katılımcıdan %{amount} tanesi bugün hedefe ulaştı",
        "week": "%{total} katılımcıdan %{amount} tanesi bu hafta hedefe ulaştı",
        "month": "%{total} katılımcıdan %{amount} tanesi bu ay hedefe ulaştı"
    },
    "doubleBonusShort": "Çifte bonus!",
    "doubleBonusLong": "Çifte bonus kazandınız.",
    "recommendedGoalDescription": "Amaçlar, ilerlemenizi takip etmenize ve motivasyonunuzu korumanıza yardımcı olur.",
    "noParticipation": "Katılım yok",
    "nothingToShow": "Görünüşe göre şu anda gösterilecek bir şey yok",
    "yourTeam": "Ekibiniz",
    "no_activity_title": "Aktivite yok",
    "brandSupport": {
        "description": "Polar ve Withings akıllı saatlerle aktivite senkronizasyonu desteği ekledik. Harekete geçme zamanı!"
    },
    "no_tracked_activities": "Henüz hiçbir aktiviteyi takip etmediniz.",
    "button_leave_community": "Topluluktan ayrıl",
    "button_delete_challenge": "Şunu sil: %{challengeType}",
    "button_delete_community": "Topluluğu sil",
    "button_delete_activity": "Aktiviteyi sil",
    "library_header_description": "Sağlıklı yaşam yolculuğunuzda sizi eğitecek, sürece dahil edecek ve size ilham verecek orijinal içerikler.",
    "library_searchbar": "Kütüphanede ara…",
    "library_page_header": "Sağlıklı yaşam yolculuğunuzda sizi eğitecek, sürece dahil edecek ve size ilham verecek orijinal içerikler.",
    "onboarding_button_title": "Bitirdim",
    "refresh_bar": "Güncellemek için buraya tıklayın",
    "content": {
        "min_read": "%{readingTime} dakikalık okuma"
    },
    "noMembers": "Üye yok",
    "saved": "Kaydedildi",
    "forYou": "Sizin için",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} -",
    "youCanEarnThisBadge": "Bu rozeti her %{period} içinde bir kez kazanabilirsiniz",
    "emailPreferences": "E-posta tercihleri",
    "unsubscribeText": "Tüm e-posta güncellemelerini devre dışı bırak",
    "savingText": "Kaydediliyor...",
    "wrongTryLater": "Bir şeyler ters gitti. Lütfen daha sonra tekrar deneyin.",
    "preferencesSaved": "Tercihler kaydedildi",
    "recommendedForYou": "Sizin için önerilen",
    "formerMember": {
        "label": "Eski üye"
    },
    "selectionsFromLibrary": "Kütüphanemizden sizin için seçtiklerimiz",
    "goalsInfo": {
        "desc1": "iyilik halinizi artırmaya odaklanmak için",
        "desc2": "Maksimum sayıda amaç belirlediniz."
    },
    "createMyOwn": "Benimkini oluştur",
    "isAllSet": "her şey hazır.",
    "undoLabel": "Geri al",
    "terms": "Koşullar",
    "placeOrder": "Sipariş verin",
    "item": "Öğe",
    "redeemFor": "Şunun için kullan:",
    "confirmYourOrder": "Siparişinizi onaylayın",
    "orderComplete": "Sipariş tamamlandı",
    "redeemedFor": "Şunun için kullanıldı:",
    "orderDetails": "Sipariş Ayrıntıları",
    "bonusGoalReward": "Bonus amaç ödülü",
    "orderSummary": "Sipariş özeti",
    "logoutSSO": {
        "title": "%{programName} programından çıkış yaptınız.",
        "description": "Yakında görüşmek üzere!",
        "signinAgain": "Tekrar oturum açmak için buraya tıklayın"
    },
    "nothing_to_show": "Şu anda gösterilecek bir şey yok",
    "no_saved_content": "Kaydedilmiş içeriğiniz yok",
    "restarts_every_week": "Her hafta yeniden başlar",
    "myGoals": "Amaçlarım",
    "goalGallery": "Amaç galerisi",
    "share_smth": "Bir şeyler paylaşın...",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Adım hedefimiz artık daha akıllı.",
            "description": "Haftalarınız her zaman farklı. Artık hedefleriniz de öyle. \nAkıllı Mod ile adım hedefiniz gerçek hayattaki aktivite düzeyinize göre kendini ayarlayacaktır. \nBaşarınız ve iyilik haliniz düşünülerek ayarlanmıştır.",
            "action": "Göz atın."
        },
        "mePage": {
            "title": "Yeni Ben",
            "description": "İlginizi çeken şeyleri daha kolay bulmanızı sağlamak için Ben bölümünü yeniden tasarladık. Mutlaka göz atın.",
            "letsSeeBtn": "Bakalım!",
            "llaterBtn": "Belki daha sonra"
        },
        "bellEAP": {
            "title": "Çalışan ve Aile Yardım Programı çevrimiçi platformunuza hoş geldiniz.",
            "description": "Sizin ve uygun aile üyelerinizin yararlanabileceği, iyilik halini ve yaşam zorluklarını destekleme amaçlı araçları ve hizmetleri keşfedin",
            "button": "Şimdi bağlanın veya istediğiniz zaman Hızlı Bağlantılar sayfasını ziyaret edin"
        },
        "quickActivityLogView": {
            "title": " Son aktivitenizi görmenin daha hızlı bir yolu",
            "description": "Artık aktivite günlüğünüzü görmek için ilerleme çubuğuna tıklayabilirsiniz."
        }
    },
    "goalSmartMode": {
        "title": "Akıllı Mod",
        "description": "Son aktivite seviyenize göre kişiselleştirilmiş haftalık hedefler alın.",
        "status": "Bu amaç için Akıllı Mod durumu: %{status}.",
        "infoModal": {
            "descriptionOne": "Akıllı Mod açıkken, bu amacın hedefi, son aktivite seviyenize bağlı olarak her hafta değişecektir.",
            "descriptionTwo": "Başarıya ulaşmanız için sizi tam da olması gerektiği kadar zorlayacağız.",
            "instructions": "Akıllı Modu, %{settings} kısmından açabilir veya kapatabilirsiniz"
        },
        "settings": {
            "switch": "Adım hedefim için Akıllı Modu etkinleştir",
            "description": "Akıllı Mod açık olduğunda her haftanın başında yeni bir adım hedefi alırsınız."
        },
        "enableSmartMode": "Akıllı Modu Etkinleştir",
        "settingsModal": {
            "descriptionTurnOn": "Adım hedefiniz, aktivitenize bağlı olarak her hafta değişecektir",
            "descriptionTurnOff": "Adım amaç hedefiniz artık her hafta kişiselleştirilmeyecek"
        }
    },
    "On": "Açık",
    "Off": "Kapalı",
    "top_posts": "En iyi gönderiler",
    "most_recent": "En yeni",
    "browseByTopic": "Konuya göre göz at",
    "video": "Video",
    "enable": "Etkinleştir",
    "turnOff": "Kapat",
    "new_post": "Yeni gönderi",
    "new_post_in": "Yeni gönderi -",
    "dailyTarget": "Günlük hedef",
    "dailyTargetForWeek": "Haftanın günlük hedefi",
    "showMyActivityLog": "Aktivite günlüğümü göster",
    "usersReacted": {
        "oneOther": "%{userName} ve 1 kişi daha",
        "multipleOthers": "%{userName} ve %{count} kişi daha"
    },
    "reactionsModal": {
        "title": "Kutlamanın diğer yolları",
        "description": "Yeni sosyal gönderi tepkileriyle iş arkadaşlarınızı neşelendirin."
    },
    "account": "Hesap",
    "myWellbeingProfile": "İyilik hali profilim",
    "physicalDetailsDescription": "İyilik hali puanınızı hesaplamak için bu bilgiler gereklidir",
    "wellbeingInterests": "İyilik hali ilgi alanları",
    "myWellbeingInterests": "İyilik hali ilgi alanlarım",
    "preferredNameOptional": "Tercih edilen isim (isteğe bağlı)",
    "basicPhysicalDetails": "Temel fiziksel ayrıntılar",
    "notRegistered": {
        "infoModal": {
            "title": "Sizi bulamadık",
            "notInSystem": "sistemimizde yok.",
            "correctEmail": "Doğru hesabı (genellikle bir şirket e-posta adresi) kullandığınızdan ve yazım hatalarını kontrol ettiğinizden emin olun.",
            "emailHelp": "Daha fazla yardım için destek ekibimize e-posta gönderin:"
        }
    },
    "dontHaveAccount": "Hesabınız yok mu?",
    "wasThisHelpful": "Bu yardımcı oldu mu?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Bu sayfa ve iyilik hali puanınız ne kadar yararlı?",
        "commentSectionText": "Bunlar nasıl geliştirilebilir?",
        "commentSectionPlaceholder": "Yorum ekleyin...",
        "thankYouModal": "Geri bildiriminiz için teşekkür ederiz."
    },
    "number_connected": "%{numDevices} bağlı",
    "searchPlaceHolder": "Arama...",
    "noTeamsFound": "Hiçbir ekip bulunamadı",
    "join_a_challenge": "Bir yarışmaya katılın",
    "me_page_titles": {
        "goal": {
            "singular": "amaç",
            "plural": "amaç"
        },
        "challenge": {
            "singular": "yarışma",
            "plural": "yarışma"
        }
    },
    "seeMoreText": "...daha fazlasını görün",
    "adjust_entry": "Lütfen girişi ayarlayın.",
    "overTracking": {
        "title": "Aşırı takip uyarısı",
        "desc1": {
            "singular": "Bu giriş denetlenecektir.",
            "plural": "Bu girişler denetlenecektir."
        },
        "desc2": "Kasıtlı olarak aşırı takip yapılması hesabın askıya alınmasına neden olabilir.",
        "button_edit": "Girişlerimi düzenle",
        "button_confirm": "Olduğu gibi gönder"
    },
    "oneEventAttendee": "1 katılımcı",
    "multipleEventAttendees": "%{num} katılımcı",
    "to": "-",
    "eventBonusFull": "Bu etkinliğe katıldığınız için %{number} bonus %{points} kazanacaksınız. ",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Bu makaleyi beğendiniz mi? ",
    "didYouLikeVideo": "Bu videoyu beğendiniz mi?",
    "tellUsMore": "Bize daha fazla bilgi verin...",
    "thanksForFeedback": "Geri bildiriminiz için teşekkür ederiz.",
    "challengesSubtitle": "Diğer katılımcılarla birlikte bir hedefe ulaşın ya da kazanmak için oynayın. ",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Health Wellbeing",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Health Virtual Care",
    "virtualCare": "Virtual Care",
    "changePassword": {
        "telus": {
            "info": "Parolanız %{telusVC} hesabınız aracılığıyla yönetilmektedir.",
            "button": "%{virtualCare} parolamı değiştir"
        }
    },
    "actions": "eylemler",
    "onAndUpcoming": "Devam eden ve yaklaşan",
    "termsAndPrivacyPolicyNew": "Devam ederek aşağıdakileri kabul etmiş olursunuz:",
    "invitedToTeam": "%{firstName} %{lastName} adlı kişinin ekibine davet edildi",
    "decline": "Reddet",
    "invitedToChallenge": "%{firstName} %{lastName} tarafından davet edildi",
    "goalsCard": {
        "emptyStateTitle": "Belirlenmiş hiçbir amacınız yok"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Hiçbir yarışmada değilsiniz",
        "buttonLabel": "Yarışmaları keşfedin"
    },
    "menu": "Menü",
    "everyone": "Herkes",
    "confirmEmployeeID": "Çalışan Kimliğini Onayla",
    "employeeIDNoMatch": "Bu kimlikler henüz uyuşmuyor",
    "hidePost": "%{ownerName} tarafından paylaşılan gönderileri gizle",
    "hidingUserPostToast": {
        "success": {
            "title": "Kullanıcı Gizli",
            "message": "Bu kullanıcının gönderilerini artık göremeyeceksiniz."
        }
    },
    "moderateHideUserDescription": "Bu kullanıcı için gönderileri gizlemek, kullanıcıya özel içeriği akıştan kaldıracaktır.",
    "startsInOneDay": "1 gün sonra başlıyor",
    "endsInOneDay": "1 gün sonra sona eriyor",
    "endsToday": "Bugün sona eriyor",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "sistemimizde yok. Doğru girdiniz mi?",
            "administrator": "Yeni bir çalışansanız Çalışan Kimliğiniz henüz bizde olmayabilir. Tekrar ne zaman deneyebileceğinizi lütfen yöneticinize sorun.",
            "emailNotInSystem": "Yeni bir çalışansanız e-posta adresiniz henüz sistemimize eklenmemiş olabilir. Tekrar ne zaman deneyebileceğinizi lütfen yöneticinize sorun.",
            "eligibleEmail": "uygun bir e-posta adresi değil. Doğru girdiniz mi?"
        }
    },
    "oneMember": "1 üye",
    "programCode": {
        "infoModal": {
            "unique": "Şirketinizin size genellikle e-postayla sağlanan benzersiz bir program kodu vardır.",
            "support": "Kodunuzu bulamazsanız sağlıklı yaşam programı yöneticinizle iletişime geçin veya şirket adınızla birlikte support@sproutatwork.com adresine e-posta gönderin."
        },
        "instructions": "Başlamak için işvereniniz tarafından sağlanan program kodunu girin"
    },
    "whatsMyProgramCode": "Program kodum nedir?",
    "enjoyApp": "Mobil uygulamamızın keyfini çıkarın",
    "programCodeLabel": "Program kodu",
    "createdByMembersChallenges": "Üyeler tarafından oluşturuldu",
    "invites": "Davetler",
    "recommendedContentTitle": "Sizin için kütüphane seçimleri",
    "amountExchanged": "Değiştirilen tutar",
    "orderStatus": "Sipariş durumu",
    "orderSuccessfulyyItemForConfirmation": "Sipariş başarılı! %{email} adresine bir onay gönderildi.",
    "orderedOnDateText": "%{orderCreatedTime} tarihinde sipariş edildi",
    "personalize": {
        "communities": {
            "title": "Topluluklara katılın",
            "description": "Topluluklar, ilgi alanları ortak olan insanları birbirine bağlar. Topluluklara istediğiniz zaman katılabilir veya bir topluluktan istediğiniz zaman ayrılabilirsiniz."
        },
        "objectives": {
            "title": "Amaçlarım",
            "description": "Neye başlamanıza veya neyi sürdürmenize yardımcı olabiliriz? Bunu önerilerimizi geliştirmek için kullanacağız."
        },
        "topics": {
            "title": "İyilik hali konularım",
            "description": "Bu seçimler hakkında daha fazla ipucu ve nasıl yapılır içerikleri göreceksiniz."
        }
    },
    "recommendedCardDesc": "İyilik halinizi iyileştirmeye odaklanmak için en fazla 3 amaç belirleyin",
    "accessibility": {
        "track_activity": "Aktiviteyi takip edin",
        "cardbody": "Kart Gövdesi",
        "cardcontainer": "Kart Kabı",
        "cardfooter": "Kart Altbilgisi",
        "unstartedChallengeHeader": "Başlatılmamış Yarışma",
        "activeOrEndedChallengeWrapper": "Yarışma Paketi",
        "activeOrEndedChallengeHeader": "Yarışma Başlığı",
        "goalHeader": "Amaç Başlığı",
        "openOptions": "Seçenekler'i açın"
    },
    "teams": {
        "teamInvites": "Ekip davetleri",
        "findTeam": "Bir ekip bulun",
        "teamFull": "Ekip dolu"
    },
    "deleteAccountText": "Sprout At Work hesabınızı ve tüm verilerini kalıcı olarak silin",
    "deleteAccountButtonTitle": "Hesabımı sil",
    "joinTeamActionSheetText": "Bu yarışmaya katılmak için bir ekibe katılın veya bir ekip oluşturun",
    "frequencyNone": "hiçbiri",
    "quickLinkTitle": "Hızlı bağlantılar",
    "moreTab": "Daha fazla",
    "addedBy": "%{companyName} tarafından eklendi",
    "teamsTitle": "Ekipler",
    "helpAndSupport": "Uygulama yardımı ve desteği",
    "feedbackTitle": "Geri bildirimde bulunun",
    "feedbackDescription": "Uygulamada neyi beğendiğinizi ve hangi noktaları geliştirebileceğimizi bize bildirin.",
    "leaveTeamAction": "Ekipten ayrıl",
    "teamActions": "Ekip eylemleri",
    "leaveTeamLeaveChallenge": "Bu ekipten ayrılmak, yarışmadan ayrıldığınız anlamına gelir. Katılmaya devam etmek için bir ekipte yer almanız gerekecektir.",
    "familyMembers": "Aile üyeleri",
    "familyMembersDescription": "Aile üyelerinin 16 yaşından büyük olması gerekir. Platformun tamamına tam erişimleri ve görünürlükleri olacaktır.",
    "learnMoreButton": "Daha Fazla Bilgi Edinin",
    "thvcSelection": {
        "signUpUsingTelus": "TELUS Health Virtual Care hesabınızı kullanarak kaydolun",
        "loginGetStarted": "Başlamak için Virtual Care'de oturum açın",
        "haveAccount": "Virtual Care hesabınız var mı?",
        "emailHelp": "Yardıma mı ihtiyacınız var? Destek ekibimizle şuradan iletişime geçin:",
        "yes": "Evet",
        "signMeUp": "Hayır, beni kaydet"
    },
    "inviteFamilyMember": {
        "label": "Aile üyesini davet et",
        "btn": "Davet Gönder",
        "email": "E-posta adresi*",
        "firstName": "Ad*",
        "lastName": "Soyadı*",
        "approval": "Bu aile üyesini %{company} şirketine davet etme onayımın olduğunu teyit ediyorum",
        "multiSelect1": "Bu aile üyesi bölgenizde geçerli reşit olma yaşının üzerinde mi?",
        "multiSelect2": "Bu aile üyesi en az 16 yaşında mı?",
        "confirmTermsPolicy": "Bu kişinin yasal vasisi olduğumu teyit ediyorum. Bakmakla yükümlü olduğum kişinin platformun kullanımını kabul edebilecek kadar olgun olduğunu düşünüyorum ve platforma katılmasına izin veriyorum. Bakmakla yükümlü olduğum kişiye platformda sorumlu davranma gerekliliği ile platformun kendisine ait verileri toplama ve kullanma şeklini açıklayacağım.",
        "onTheirBehalf": "onun adına.",
        "confirm": "Evet, yukarıdakileri onaylıyorum",
        "warning": "Kayıt yaptırmak için aile üyesinin en az 16 yaşında olması gerekir",
        "errorMsg": "Devam etmeden önce lütfen hataları inceleyin"
    },
    "deleteFamilyMember": {
        "desc": "Bir aile üyesinin hesabının silinmesi kalıcıdır.",
        "btn": "Aile üyesini sil",
        "confirmation": {
            "title": "Aile üyesi silindi",
            "desc": "%{fullName} adlı kişinin hesabı silindi"
        },
        "areYouSure": "%{fullName} adlı kişinin hesabını silmek istediğinizden emin misiniz?"
    },
    "familyInvitationStatus": {
        "active": "Aktif",
        "sent": "Davet gönderildi"
    },
    "familyInvitationSent": {
        "title": "Davet e-postası gönderildi",
        "desc": "%{fullName} adlı kişiye davet gönderildi"
    },
    "programCodeSignup": "Lütfen \"%{signUpLabel}\" öğesine tıkladıktan sonra %{programCodeLabel} %{programCode} öğesini kullanın.",
    "notJoinedCommunityLabel": "Üyelerin neler paylaştığını görmek için bu topluluğa katılın",
    "moda": {
        "installApp": {
            "title": "Lütfen dikkat: Moda Health üyeleri Sprout at Work'e yalnızca Üye Panoları üzerinden erişebilirler.",
            "subtitle": "Sprout at Work'ü akıllı telefonunuzda kullanmak için:",
            "stepOneA": "1. Sprout at Work mobil uygulamasını yükleyin.",
            "stepOneB": "Mobil uygulamadan kaydolmayın veya mobil uygulama üzerinde oturum açmayın.",
            "stepTwo": "2. Cep telefonunuzdan Üye Panonuzda oturum açın",
            "stepThree": "3. Sprout sağlıklı yaşam programına göz atın ve bu bağlantıyı takip edin. Sprout at Work mobil uygulamasını açacaktır.\n\n"
        }
    },
    "HRISLocationSelection": {
        "title": "Hangi ülkeden çalışıyorsunuz?"
    },
    "visibilitySettings": {
        "title": "Görünürlük Ayarları",
        "desc1": "Şirketinizdeki diğer Wellbeing uygulaması üyelerine görünür olmanız uygun mu?",
        "desc2": "Bunu daha sonra istediğiniz zaman değiştirebilirsiniz.",
        "moreTextQ1": "Diğer insanlar neleri görebilir?",
        "moreTextAnswer1": "Adınız, profil fotoğrafınız ve temel profil bilgileriniz (departman ve konum gibi) şirketinizdeki kişiler tarafından görülebilir. Bu, uygulamayı daha sosyal ve eğlenceli hale getirir.",
        "moreTextQ2": "Nerede görünürüm?",
        "moreTextAnswer2": "Katıldığınız yarışmalar, topluluklar ve etkinlikler için, puan tablolarında ve arama sonuçlarında katılımcı olarak gösterileceksiniz. Bunu daha sonra ayarlayabilirsiniz.",
        "moreTextAnswer3": "Boyunuz, kilonuz veya takip ettiğiniz aktivite gibi kişisel sağlık bilgilerinizi paylaşmıyoruz veya göstermiyoruz.",
        "btnAgree": "Beni göstermende bir sakınca yok",
        "btnDisagree": "Diğer üyelerin beni görmesine izin verme"
    },
    "privacyPolicyReadMore": "Daha fazla bilgi edinmek için Gizlilik Politikamızı okuyun",
    "tellMeMore": "Daha fazla bilgi istiyorum",
    "helpUsImprove": {
        "title": "İyileştirmemize Yardımcı Olun",
        "desc1": "Anonim kullanım verilerini kaydeden araçlar kullanıyoruz. İnsanların neleri görüntülediği ve nelere tıkladığına dair eğilimleri görmek, uygulamayı daha iyi hale getirmemize yardımcı oluyor.",
        "desc2": "Bunu istediğiniz zaman kapatabilirsiniz.",
        "moreTextQ1": "Nelere bakıyoruz?",
        "moreTextAnswer1": "Biz genel eğilimler ve istatistiklerle ilgileniyoruz. Bu nedenle bireysel düzeydeki verilere bakmıyoruz.",
        "moreTextQ2": "Verilerinizi paylaşmıyoruz",
        "moreTextAnswer2": "Bu veriler yalnızca bu uygulamayı daha iyi hale getirmeye yardımcı olması için, uygulamayı oluşturan kişiler tarafından kullanılabilir. İşvereniniz de dahil olmak üzere diğer şirketlerle paylaşmıyoruz.",
        "moreTextQ3": "Verileriniz anonimdir",
        "moreTextAnswer3": "Araçlarımız adınızı, tam konumunuzu veya hiçbir kişisel sağlık bilginizi kaydetmez.",
        "btnAgree": "Kullanımımı anonim olarak takip et",
        "btnDisagree": "Takibe izin vermiyorum"
    },
    "deleteAccountTextAppName": "%{appName} hesabınızı ve tüm verilerini kalıcı olarak silin",
    "anonymousMember": "Anonim Üye",
    "activitiesToTrack": {
        "title": "Takip edilecek aktiviteler"
    },
    "includedInMembership": "Üyeliğinize dahildir",
    "invalidDate": "Geçersiz tarih",
    "discardsStreamPost": {
        "discardTitle": "Gönderi iptal edilsin mi?",
        "discardChangesTitle": "Değişiklikler iptal edilsin mi?",
        "discardPostText": "Gönderinizi iptal etmek istediğinizden emin misiniz?",
        "discardPostChangesText": "Değişikliklerinizi iptal etmek istediğinizden emin misiniz?"
    },
    "trackActivityModalTitle": "%{date} için takip et",
    "noPosts": "Görülecek gönderi yok",
    "goalIcon": "Amaç simgesi",
    "resetsOn": "%{date} tarihinde sıfırlanır",
    "clickForHelp": "Yardım için buraya tıklayın",
    "trackActivityInputLabel": "%{unit} %{activityName} %{dateFormat} girin",
    "itemsFound": "Bulunan öğeler",
    "tagState": {
        "active": "Aktif",
        "notActive": "Aktif değil"
    },
    "bonusCheckmarkLabel": "Tamamlama için %{bonusLabel} bonus puanı alındı",
    "searchBar": {
        "searching": "%{term} aranıyor",
        "result": "arama sonuçları"
    },
    "activityProgress": "Aktivite ilerlemesi - %{levelName} %%{percentFilled} - %{daysLeft} gün sonra sıfırlanır",
    "bookmark": {
        "remove": "Kayıtlı öğelerden kaldır",
        "save": "Bu öğeyi kaydet"
    },
    "bonusMark": {
        "earn": "%{qty} %{points} kazanın",
        "earned": "%{qty} %{points} kazandınız"
    },
    "tabToTrackActivity": "Aktiviteyi izlemek için dokunun",
    "videoElementLabel": "%{title}, süre %{duration}. Videoyu oynatmak için iki kez dokunun",
    "updatedPoliciesPopup": {
        "title": "Koşullarımızı güncelledik",
        "details": "Aşağıdaki güncellenmiş politikalarımızı okumanızı öneririz:",
        "disclaimer": "Aşağıdaki düğmeye tıklayarak güncellenen politikaları kabul etmiş ve onaylamış olursunuz.",
        "agree": "Kabul ediyorum"
    },
    "editActivityLog": {
        "canNotEditItem": "Bu girişi düzenleyemezsiniz",
        "canNotEditItemDescription": "Cihazlardan veya uygulamalardan senkronize edilen aktiviteler için düzenleme yapılamaz.",
        "updatedItem": "Aktivite güncellendi",
        "updatedItemDescription": "Değişiklikleriniz kaydedildi."
    },
    "login_with_email": "E-posta ile oturum aç",
    "healthconnect_not_available": "Health Connect'e bağlanılamıyor. Health Connect uygulamasında izinlerin etkinleştirildiğinden lütfen emin olun.",
    "registrationField": {
        "required": {
            "firstName": "Lütfen adınızı girin",
            "lastName": "Lütfen soyadınızı girin",
            "email": "Lütfen geçerli bir e-posta adresi girin",
            "password": "Lütfen geçerli bir parola girin"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Lütfen adınızı girin",
        "lastName": "Lütfen soyadınızı girin"
    },
    "requiredValidValue": "Lütfen %{value} için geçerli bir değer girin",
    "passwordHidden": "Parola gizleniyor. Parolayı göstermek için dokunun",
    "passwordShown": "Parola gösteriliyor. Parolayı gizlemek için dokunun",
    "libraryHeaderContent": {
        "category": "Bu ürün %{category} kategorisine aittir.",
        "points": "%{points} puan kazanın."
    },
    "scoreCurrentPeriod": "%{text}, %{startDate} ile %{endDate} tarihleri arasındadır",
    "scoreCurrent": "%{text}, %{points} puandır",
    "abbotResetPasswordModal": {
        "title": "Geçtiğimiz yıldan kalma bir hesaba mı erişmeye çalışıyorsunuz?",
        "text": " Geçen yılki yarışmaya kaydolduysanız bu hesap artık çalışmaz. Bu yıl için kaydolmanız gerekiyor.",
        "goToResetPasswordBtn": "%{currentYear} içinde kaydoldum",
        "goToSignupBtn": "%{currentYear} içinde kaydolmadım"
    },
    "challengeRegistrationClosed": "Kayıtlar Kapandı - Yarışma Başladı",
    "stopSupportGoogleFit": {
        "banner": {
            "title": "Google Fit kaldırılıyor",
            "description": "Etkinliğinizi otomatik olarak takip etmeye devam etmek için Health Connect'e geçin.",
            "linkBtn": "Health Connect'e geç"
        },
        "newFeatureModal": {
            "label": "İşlem gerekli",
            "title": "Google Fit artık etkinlik senkronizasyonunu desteklemiyor",
            "web": {
                "doNotHaveApp": "Henüz uygulamamız yok mu?",
                "getAppText": "Buradan indirin,",
                "dateNotIncludedDescription": "Bunun yerine Google's Health Connect'e geçmek için akıllı telefonunuzu kullanın.",
                "dateIncludedDescription": "Google Fit entegrasyonunu %{date} tarihinde kaldıracağız. Bunun yerine Google's Health Connect'e geçmek için akıllı telefonunuzu kullanın."
            },
            "mobile": {
                "dateNotIncludedDescription": "Etkinliğinizi otomatik olarak takip etmeye devam etmek için Health Connect'e geçin.",
                "dateIncludedDescription": "Google Fit entegrasyonunu %{date} tarihinde kaldıracağız. Etkinliğinizi otomatik olarak takip etmeye devam etmek için Health Connect'e geçin.",
                "buttonLabel": "Health Connect'e geç"
            }
        }
    },
    "RBCTaxableRewardWarning": "Lütfen wellness platformu üzerinden kullanılan tüm ödüllerin vergiye tabi bir fayda olarak kabul edileceğini ve ilgili değerin maaş bordronuzda gelir olarak yansıtılacağını unutmayın."
};